<template>
  <v-app class="suppliers">
    <Header ref="header"/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 sm7 md6 xl4 px-2 v-if="!currentSupplier && !showStatistics">
            <div style="display: flex;">
              <v-autocomplete v-if="!filterInactive" :items="filterSuppliers" v-model="filterSupplierList" item-text="name" prepend-icon="a-factory" return-object multiple @change="supplierFilterChanged" class="supplierFilter" style="margin-right: 20px; min-width: 150px; max-width: 450px;"/>
              <v-btn flat @click="startShowStatistics" v-if="!showProduction && !currentField && !showDeliveryReport && !supplierInformation && !filterInactive && !showStatistics" class="bw-4">Statistics</v-btn>
            </div>
          </v-flex>
          <v-flex text-xs-left xs12 sm7 md6 xl4 v-if="currentSupplier && !showStatistics && !showContract">
            <v-btn flat v-if="canCreateContract" @click="createContract" class="bw-5">Create contract</v-btn>
            <v-btn flat v-if="hasContract" @click="displayContract(contract)" class="bw-4">Contract</v-btn>
            <v-btn flat @click="startShowProduction" v-if="!showProduction && !currentField && !showDeliveryReport && supplierInformation && currentSupplier.id" class="bw-5">Show production</v-btn>
            <v-btn flat @click="startShowDeliveryReport" v-if="!showDeliveryReport && !currentField && !showProduction && supplierInformation && currentSupplier.id" class="bw-5">Delivery report</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 sm5 md6 xl8 v-if="!showStatistics && !showContract">
            <v-btn flat v-if="!currentSupplier && !showStatistics" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentSupplier && !showStatistics" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentSupplier && !showProduction && !showDeliveryReport && !showStatistics" v-on:click="editNewSupplier" class="bw-6">Create new supplier</v-btn>

            <v-btn flat v-if="currentSupplier && !showProduction && !currentField && !showDeliveryReport && !supplierInformation" @click="toggleFilterFieldInactive(false)" class="bw-4" :style="buttonStyleFilterFieldActive" :disabled="!filterFieldInactive">Active</v-btn>
            <v-btn flat v-if="currentSupplier && !showProduction && !currentField && !showDeliveryReport && !supplierInformation" @click="toggleFilterFieldInactive(true)" class="bw-4" :style="buttonStyleFilterFieldInactive" :disabled="filterFieldInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="currentSupplier && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport && !supplierInformation" @click="openSupplierInformation()" class="bw-6">Supplier information</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport && !fieldInformation" @click="fieldInformation = true; currentPlanting = null" class="bw-5">Field information</v-btn>

            <v-btn flat v-if="currentSupplier && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport && supplierInformation" :disabled="saveButtonDisabled" @click="saveSupplier" class="bw-3">{{ currentSupplier.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport && fieldInformation && !currentPlanting" @click="saveField" :disabled="saveFieldButtonDisabled" class="bw-3">{{ currentField.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport && fieldInformation && currentPlanting" @click="savePlanting" :disabled="savePlantingButtonDisabled" class="bw-3">{{ currentPlanting.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentSupplier && currentSupplier.id > 0 && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport && supplierInformation && !currentPlanting" @click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentField && currentField.id > 0 && !showProduction && !showDeliveryReport && fieldInformation && !currentPlanting" @click="confirmDeleteFieldDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentPlanting && currentPlanting.id > 0 && !showProduction && !showDeliveryReport && fieldInformation" @click="confirmDeletePlantingDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentField && currentField.id > 0 && !showProduction && !showDeliveryReport && fieldInformation && !currentPlanting" @click="addPlanting" class="bw-4">Add planting</v-btn>
            <v-btn flat v-if="currentSupplier && currentSupplier.id > 0 && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport && supplierInformation" @click="addField" class="bw-3">Add field</v-btn>
            <v-btn flat v-if="currentSupplier && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport && supplierInformation" @click="currentSupplier.id > 0 ? cancelSupplierInformation() : cancelSupplier()" class="bw-3">{{ currentSupplier.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
            <v-btn flat v-if="currentSupplier && !(currentField || currentPickupAddress) && !showProduction && !showDeliveryReport && !supplierInformation" @click="cancelSupplier" class="bw-3">Close</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport && !fieldInformation" @click="cancelField" class="bw-3">Close</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport && fieldInformation && !currentPlanting" @click="currentField.id > 0 ? fieldInformation = false : cancelField()" class="bw-3">{{ currentField.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
            <v-btn flat v-if="currentField && !showProduction && !showDeliveryReport && fieldInformation && currentPlanting" @click="cancelPlanting" class="bw-3">{{ currentPlanting.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
            <v-btn flat v-if="showProduction" @click="printProduction" class="bw-3">Print</v-btn>
            <v-btn flat v-if="showProduction" @click="excelProduction" class="bw-3">Excel</v-btn>
            <v-btn flat v-if="showProduction" @click="endShowProduction" class="bw-3">Close</v-btn>
            <v-btn flat v-if="showDeliveryReport" @click="printDeliveryReport" class="bw-3">Print</v-btn>
            <v-btn flat v-if="showDeliveryReport" @click="excelDeliveryReport" class="bw-3">Excel</v-btn>
            <v-btn flat v-if="showDeliveryReport" @click="endShowDeliveryReport" class="bw-3">Close</v-btn>
          </v-flex>
          <v-flex text-xs-left xs12 v-if="showStatistics">
            <div style="display: inline-flex;" class="supplierStatisticOptions">
              <v-autocomplete :items="filterSuppliers" v-model="filterSupplierList" item-text="name" prepend-icon="a-factory" return-object multiple @change="supplierFilterChanged" class="supplierFilter" style="margin-right: 20px; min-width: 350px; max-width: 500px;"/>
              <v-autocomplete :items="getFilterFields" v-model="filterFieldList" item-text="address.nameAndText" prepend-icon="a-address" return-object multiple @change="fieldFilterChanged" class="fieldFilter" style="margin-right: 20px; min-width: 400px; max-width: 700px;"/>
              <v-autocomplete :items="filterProductions" v-model="filterProductionList" item-text="name" prepend-icon="schedule" return-object multiple @change="productionFilterChanged" class="productionFilter" style="margin-right: 20px; min-width: 150px; max-width: 250px;"/>
              <v-autocomplete :items="statisticsColumns" v-model="statisticsColumnList" item-text="label" prepend-icon="view_column" return-object multiple @change="statisticsColumnChanged" class="statisticsColumns" style="margin-right: 20px; min-width: 150px;"/>
            </div>
            <div style="display: block; float: right;">
              <v-btn flat @click="endShowStatistics" v-if="!showProduction && !currentField && !showDeliveryReport && !supplierInformation && showStatistics" class="bw-5">Close statistics</v-btn>
            </div>
          </v-flex>
          <v-flex text-xs-left xs12 v-if="showStatistics && !showStatisticsCompare" style="padding-top: 5px;">
            <div style="display: inline-flex;" class="supplierStatisticOptions">
              <v-btn flat @click="startShowStatisticsCompare" class="bw-5">Open compare</v-btn>
            </div>
          </v-flex>
          <v-flex text-xs-left xs12 v-if="showStatistics && showStatisticsCompare" style="padding-top: 5px;">
            <div style="display: inline-flex;" class="supplierStatisticOptions">
              <v-autocomplete :items="filterSuppliers" v-model="otherFilterSupplierList" item-text="name" prepend-icon="a-factory" return-object multiple @change="otherSupplierFilterChanged" class="supplierFilter" style="margin-right: 20px; min-width: 350px; max-width: 500px;"/>
              <v-autocomplete :items="getOtherFilterFields" v-model="otherFilterFieldList" item-text="address.nameAndText" prepend-icon="a-address" return-object multiple @change="otherFieldFilterChanged" class="fieldFilter" style="margin-right: 20px; min-width: 400px; max-width: 700px;"/>
              <v-autocomplete :items="filterProductions" v-model="otherFilterProductionList" item-text="name" prepend-icon="schedule" return-object multiple @change="otherProductionFilterChanged" class="productionFilter" style="margin-right: 20px; min-width: 150px; max-width: 250px;"/>
              <v-btn flat @click="endShowStatisticsCompare" class="bw-5">Close compare</v-btn>
            </div>
            <div style="display: block; float: right;">
            </div>
          </v-flex>
          <v-flex text-xs-left xs12 md4 v-if="showContract && !sendContractStarted">
            <v-btn flat v-if="canPrintContract" @click="printContract" :disabled="contractDirty" class="bw-3">Print</v-btn>
            <v-btn flat v-if="canSendContract" @click="startSendContract" :disabled="contractDirty" class="bw-3">Send</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 md8 v-if="showContract && !sendContractStarted">
            <v-btn flat @click="saveContract" class="bw-3" :disabled="!canSaveContract">Save</v-btn>
            <v-btn flat @click="confirmDeleteContractDialog = true" v-if="canDeleteContract" class="bw-3">Delete</v-btn>
            <v-btn flat @click="cancelContract" class="bw-3">{{ currentContract.id > 0 ? 'Close' : 'Cancel' }}</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 v-if="showContract && sendContractStarted">
            <v-btn flat @click="sendContractStarted = false" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-1 px-0 v-show="!currentSupplier && !showStatistics && !showContract">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex xs12 style="overflow-y: auto;">
            <v-container fluid>
              <v-layout wrap>
                <v-flex xs12 xl5 style="padding-right: 20px;">
                  <div style="border: 1px solid #DDDDDD; border-radius: 3px;">
                    <v-data-table :headers="filterInactive ? headersInactive : headers" :items="filteredSuppliers" :pagination.sync="filterInactive ? paginationInactive : pagination" hide-actions>
                      <template v-slot:items="props">
                        <tr @click="selectSupplier(props.item)" class="selectable">
                          <td class="text-xs-left" style="width: 100px;">{{ props.item.number }}</td>
                          <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.name }}</td>
                          <td class="text-xs-right" style="width: 80px; white-space: nowrap;" v-if="!filterInactive">{{ props.item.size ? props.item.size.toFixed(2) + ' ha' : ''}}</td>
                          <td class="text-xs-right" style="width: 80px; white-space: nowrap;" v-if="!filterInactive">{{ props.item.forecast ? props.item.forecast.toLocaleString() : ''}}</td>
                          <td class="text-xs-right" style="width: 80px; white-space: nowrap;" v-if="!filterInactive">{{ props.item.harvestSize ? props.item.harvestSize.toFixed(2) + ' ha' : ''}}</td>
                          <td></td>
                        </tr>
                      </template>
                      <template v-slot:footer>
                        <tr class="supplierTotal">
                          <td class="text-xs-left" colspan="2" style="padding-left: 10px;">Total</td>
                          <td class="text-xs-right" style="padding-right: 10px; white-space: nowrap;">{{ getTotalSizeSupplier(filteredSuppliers) ? getTotalSizeSupplier(filteredSuppliers).toFixed(2) + ' ha' : ''}}</td>
                          <td class="text-xs-right" style="padding-right: 10px; white-space: nowrap;">{{ getTotalForecastSupplier(filteredSuppliers) ? getTotalForecastSupplier(filteredSuppliers).toLocaleString() : ''}}</td>
                          <td class="text-xs-right" style="padding-right: 10px; white-space: nowrap;">{{ getTotalHarvestSizeSupplier(filteredSuppliers) ? getTotalHarvestSizeSupplier(filteredSuppliers).toFixed(2) + ' ha' : ''}}</td>
                          <td style="padding: 0;"></td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
                <v-flex xs12 xl7 v-if="!filterInactive">
                  <div style="height: min(calc(100vh - 250px), 40vw); width: 98%;">
                    <a-chart ref="supplierChart" height="100%" width="100%" :options="supplierChartOptions" :series="supplierChartSeries"></a-chart>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentSupplier && showStatistics && !showContract">
        <v-layout style="max-height: calc(100vh - 200px);">
          <v-flex xs12 style="overflow-y: auto;">
            <div style="border: 1px solid #DDDDDD; border-radius: 3px; width: 100%;">
              <v-data-table :headers="statisticHeaders" :items="statistics" hide-actions v-if="statistics && updateCounter" class="statistics">
                <template v-slot:items="props">
                  <tr v-if="updateCounter && (props.item.type === 'SUMMARY' || props.item.type === 'TOTAL' || (isStatisticExpanded(props.item) && showStatisticsField))" :class="props.item.type === 'TOTAL' ? 'statisticsTotal' : ''">
                    <td class="text-xs-left" style="width: 15px; padding-left: 5px !important; padding-right: 0 !important; padding-top: 1px !important; padding-bottom: 0 !important; line-height: 18px !important;'" v-if="showStatisticsField">
                      <v-icon style="font-size: 20px;" v-if="showExpandIconForStatistic(props.item)" @click="statisticClicked(props.item)">chevron_right</v-icon>
                      <v-icon style="font-size: 20px;" v-if="showCollapseIconForStatistic(props.item)" @click="statisticClicked(props.item)">expand_more</v-icon>
                    </td>
                    <td class="text-xs-left" style="width: 50px; padding-right: 20px !important; white-space: nowrap;" v-if="props.item.type === 'SUMMARY'"><div style="padding-left: 8px;"><div style="width: 30px; text-align: right;">{{ props.item.treeAge + ' yr' }}</div></div></td>
                    <td class="text-xs-left" style="width: 50px; padding-right: 20px !important; white-space: nowrap;" v-if="props.item.type === 'TOTAL'"><div style="padding-left: 8px;"><div style="width: 30px; text-align: right;">Total</div></div></td>
                    <td class="text-xs-left" style="padding-left: 35px !important; padding-right: 20px !important; white-space: nowrap;" v-if="props.item.type === 'FIELD'">{{ props.item.planting.field.address.name }}</td>
                    <td class="text-xs-right" style="width: 150px !important; min-width: 150px !important; padding-right: 50px !important; white-space: nowrap;" v-if="showStatisticsColum('SIZE')">{{ props.item.planting.size ? props.item.planting.size.toFixed(2) + ' ha' : '' }}</td>
                    <td class="text-xs-right" style="width: 140px !important; padding-right: 40px !important; white-space: nowrap;" v-if="showStatisticsColum('PLANTED_AMOUNT')">{{ props.item.planting.amount ? props.item.planting.amount.toLocaleString() : '' }}</td>
                    <td class="text-xs-right" style="width: 120px !important; padding-right: 40px !important; white-space: nowrap;" v-if="showStatisticsColum('HARVEST_YEAR') && !showStatisticsCompare && isAnyStatisticExpanded">{{ props.item.productionYear ? props.item.productionYear : '' }}</td>
                    <td class="text-xs-right" style="width: 100px !important; padding-right: 30px !important; white-space: nowrap;" v-if="showStatisticsColum('HARVEST_PERCENTAGE')">{{ props.item.harvestPercentage ? props.item.harvestPercentage.toFixed(1) + '%' : '' }}</td>
                    <td class="text-xs-right" style="width: 140px !important; padding-right: 50px !important; white-space: nowrap;" v-if="showStatisticsColum('AMOUNT')">{{ props.item.amount ? props.item.amount.toLocaleString() : '' }}</td>
                    <td class="text-xs-right" style="width: 140px !important; padding-right: 50px !important; white-space: nowrap;" v-if="showStatisticsColum('AMOUNT_PER_HA')">{{ props.item.amountPerHa ? props.item.amountPerHa.toLocaleString() : '' }}</td>
                    <template v-for="(quality, q) in statisticQualities">
                      <td :key="q" class="text-xs-right" :style="'width: ' + getStatisticsQualityColumnWidth +  'px !important; padding-right: ' + getStatisticsQualityColumnPaddingRight + 'px !important; white-space: nowrap;'" v-if="showStatisticsColum('QUALITY_' + quality)">{{ getStatisticByQuality(props.item, quality) }}</td>
                    </template>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <div style="border: 1px solid #DDDDDD; border-radius: 3px; width: 100%; margin-top: 20px;" v-if="showStatisticsCompare">
              <v-data-table :headers="statisticHeaders" :items="otherStatistics" hide-actions v-if="otherStatistics && updateCounter" class="statistics">
                <template v-slot:items="props">
                  <tr v-if="updateCounter && props.item.type === 'SUMMARY' || props.item.type === 'TOTAL'" :class="props.item.type === 'TOTAL' ? 'statisticsTotal' : ''">
                    <td class="text-xs-left" style="width: 50px; padding-right: 20px !important; white-space: nowrap;" v-if="props.item.type === 'SUMMARY'"><div style="padding-left: 8px;"><div style="width: 30px; text-align: right;">{{ props.item.treeAge + ' yr' }}</div></div></td>
                    <td class="text-xs-left" style="width: 50px; padding-right: 20px !important; white-space: nowrap;" v-if="props.item.type === 'TOTAL'"><div style="padding-left: 8px;"><div style="width: 30px; text-align: right;">Total</div></div></td>
                    <td class="text-xs-left" style="padding-left: 35px !important; padding-right: 20px !important; white-space: nowrap;" v-if="props.item.type === 'FIELD'">{{ props.item.planting.field.address.name }}</td>
                    <td class="text-xs-right" style="width: 150px !important; min-width: 150px !important; padding-right: 50px !important; white-space: nowrap;" v-if="showStatisticsColum('SIZE')">{{ props.item.planting.size ? props.item.planting.size.toFixed(2) + ' ha' : '' }}</td>
                    <td class="text-xs-right" style="width: 140px !important; padding-right: 40px !important; white-space: nowrap;" v-if="showStatisticsColum('PLANTED_AMOUNT')">{{ props.item.planting.amount ? props.item.planting.amount.toLocaleString() : '' }}</td>
                    <td class="text-xs-right" style="width: 140px !important; padding-right: 50px !important; white-space: nowrap;" v-if="showStatisticsColum('HARVEST_PERCENTAGE')">{{ props.item.harvestPercentage ? props.item.harvestPercentage.toFixed(1) + '%' : '' }}</td>
                    <td class="text-xs-right" style="width: 140px !important; padding-right: 50px !important; white-space: nowrap;" v-if="showStatisticsColum('AMOUNT')">{{ props.item.amount ? props.item.amount.toLocaleString() : '' }}</td>
                    <td class="text-xs-right" style="width: 140px !important; padding-right: 50px !important; white-space: nowrap;" v-if="showStatisticsColum('AMOUNT_PER_HA')">{{ props.item.amountPerHa ? props.item.amountPerHa.toLocaleString() : '' }}</td>
                    <template v-for="(quality, q) in statisticQualities">
                      <td :key="q" class="text-xs-right" :style="'width: ' + getStatisticsQualityColumnWidth +  'px !important; padding-right: ' + getStatisticsQualityColumnPaddingRight + 'px !important; white-space: nowrap;'" v-if="showStatisticsColum('QUALITY_' + quality)">{{ getStatisticByQuality(props.item, quality) }}</td>
                    </template>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-2 px-3 v-if="currentSupplier && showProduction">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <Headline :title="currentSupplier.name" style="padding: 15px 0 5px 0;" padding-left="20px"></Headline>
            <v-data-table :headers="palletHeaders" :items="pallets" hide-actions>
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.number }}</td>
                  <td class="text-xs-left">{{ props.item.externalNumber }}</td>
                  <td class="text-xs-left">{{ props.item.stateLabel }}</td>
                  <td class="text-xs-left">{{ props.item.field ? props.item.field.address.nameAndText : '' }}</td>
                  <td class="text-xs-left"><div v-html="props.item.categoriesText"></div></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-2 px-3 v-if="currentSupplier && showDeliveryReport && deliveryReport">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <Headline :title="currentSupplier.name" style="padding: 15px 0 5px 0;" padding-left="20px"></Headline>
            <v-data-table :headers="deliveryReportHeaders" :items="deliveryReport.items" hide-actions class="deliveryReportTable">
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left" style="width: 20px; padding-left: 8px !important; padding-right: 0 !important; padding-top: 2px !important; padding-bottom: 0 !important;">
                    <div v-if="props.item.category && props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                    <div v-if="props.item.category && props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                    <div v-if="!props.item.category">&nbsp;</div>
                  </td>
                  <td class="text-xs-left" style="padding-top: 4px !important;">
                    <div v-if="props.item.category">{{ props.item.category.displayLabel }}</div>
                    <div v-if="!props.item.category" style="font-weight: bold;">Total</div>
                  </td>
                  <td class="text-xs-right" style="padding-top: 4px !important;">
                    <div :style="props.item.category ? '' : 'font-weight: bold;'">{{ props.item.amount.toLocaleString() }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-0 px-0 v-if="currentSupplier && !showProduction && !showDeliveryReport && !showContract">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto; width: 100%;" v-if="currentSupplier && !currentField">
            <Panel v-if="currentSupplier && !(currentField || currentPickupAddress) && !supplierInformation">
              <PanelColumn :title="currentSupplier.name">
                <v-flex xs12 v-if="supplierFieldSummaryReady && supplierFieldSummaryData.length">
                  <Panel title="Fields" no-margin="true" title-size="14px">
                    <v-data-table :headers="supplierFieldSummaryHeader" :items="filteredSupplierFieldSummaryData" hide-actions class="forecastTable">
                      <template v-slot:items="props">
                        <tr @click="props.item.type === 'field' ? selectField(props.item.field) : null" :class="(props.item.type === 'field' ? 'selectable' : '') + ' supplierFields' + (props.item.type === 'subTotal' ? ' subTotal' : '') + (props.item.type === 'total' ? ' total' : '')">
                          <td class="text-xs-left amount">
                            <div v-if="props.item.type === 'field'">{{ props.item.field.address.name }}</div>
                            <div v-if="props.item.type === 'subTotal'">Subtotal</div>
                            <div v-if="props.item.type === 'total'">Total</div>
                          </td>
                          <td class="text-xs-left amount" style="width: 60px;">
                            <div v-if="props.item.type === 'field' && props.item.planting">{{ props.item.planting.year }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 100px;">
                            <div class="fieldSummaryValue" v-if="props.item.planting && props.item.type === 'field'">{{ props.item.planting.size.toFixed(2) + ' ha'}}</div>
                            <div class="fieldSummaryValue" v-if="'subTotal|total'.includes(props.item.type)">{{ props.item.size ? props.item.size.toFixed(2) + ' ha' : ''}}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 135px; padding-right: 20px !important;">
                            <div class="fieldSummaryValue" v-if="props.item.type === 'field' && props.item.planting">{{ props.item.planting.amount.toLocaleString() }}</div>
                            <div class="fieldSummaryValue" v-if="'subTotal|total'.includes(props.item.type)">{{ props.item.amount ? props.item.amount.toLocaleString() : '' }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 135px; padding-right: 30px !important;">
                            <div class="fieldSummaryValue" v-if="'field|subTotal|total'.includes(props.item.type) && props.item.amountPerHa">{{ props.item.amountPerHa.toLocaleString() }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 145px; padding-right: 40px !important;">
                            <div class="fieldSummaryValue" v-if="'field|subTotal|total'.includes(props.item.type) && props.item.amountRemaining">{{ props.item.amountRemaining.toLocaleString() }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 135px; padding-right: 50px !important;">
                            <div class="fieldSummaryValue" v-if="'field|subTotal|total'.includes(props.item.type) && props.item.amountRemainingPerHa">{{ props.item.amountRemainingPerHa.toLocaleString() }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 120px; padding-right: 20px !important;">
                            <div class="fieldSummaryValue" v-if="'field|subTotal|total'.includes(props.item.type) && props.item.forecast">{{ props.item.forecast.toLocaleString() }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 135px; padding-right: 40px !important;">
                            <div class="fieldSummaryValue" v-if="'field|subTotal|total'.includes(props.item.type) && props.item.forecastPerHa">{{ props.item.forecastPerHa.toLocaleString() }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 100px; padding-right: 15px !important;">
                            <div class="fieldSummaryValue" v-if="props.item.type === 'field' && props.item.fieldAge">{{ props.item.fieldAge + ' yr'}}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 100px; padding-right: 15px !important;">
                            <div class="fieldSummaryValue" v-if="'field|subTotal'.includes(props.item.type) && props.item.plantAge">{{ props.item.plantAge + ' yr' }}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 140px; padding-right: 30px !important;">
                            <div class="fieldSummaryValue" v-if="props.item.type === 'field' && props.item.planting">{{ props.item.planting.operationalAge + ' yr'}}</div>
                          </td>
                          <td class="text-xs-right amount" style="width: 100px; padding-right: 10px !important;">
                            <div class="fieldSummaryValue" v-if="props.item.type === 'field' && props.item.planting">{{ getUtilization(props.item.planting) }} %</div>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </Panel>

                  <v-flex xs12 v-if="supplierForecastDatas && supplierForecastDatas.length && !filterFieldInactive" style="padding-top: 10px;">
                    <Panel no-margin="true">
                      <template v-for="(supplierForecastData, i) in supplierForecastDatas">
                        <v-flex xs12 class="panelTitle selectable" :style="i > 0 ? 'margin-top: 10px;' : ''" :key="'forecast_title_' + i" @click="toggleForecastYear(supplierForecastData[0].year)">
                          <v-icon style="font-size: 20px;" v-if="!showForecastYear(supplierForecastData[0].year)">chevron_right</v-icon>
                          <v-icon style="font-size: 20px;" v-if="showForecastYear(supplierForecastData[0].year)">expand_more</v-icon>
                          <div style="display: inline-block;">{{ 'Forecast ' + supplierForecastData[0].year }}</div>
                        </v-flex>
                        <v-data-table :headers="supplierForecastHeader" :items="supplierForecastData" hide-actions class="forecastTable" :key="'forecast_' + i + '_' + updateCounter" v-if="showForecastYear(supplierForecastData[0].year)">
                          <template v-slot:items="props">
                            <tr :class="props.item.type === 'TOTAL' ? 'subTotal' : ''" v-if="showForecastData(props.item)">
                              <td class="text-xs-left" style="width: 15px; padding-left: 5px !important; padding-right: 0 !important; padding-top: 1px !important; padding-bottom: 0 !important; line-height: 18px !important;'">
                                <v-icon style="font-size: 20px;" v-if="showExpandIconForSupplier(props.item)" @click="forecastFamilyClicked(props.item)">chevron_right</v-icon>
                                <v-icon style="font-size: 20px;" v-if="showCollapseIconForSupplier(props.item)" @click="forecastFamilyClicked(props.item)">expand_more</v-icon>
                              </td>
                              <td class="text-xs-left amount" style="width: 400px;">
                                <div v-if="props.item.type === 'LINE'" @click="forecastFamilyClicked(props.item)" style="cursor: pointer;">
                                  {{ props.item.family.displayLabel }}
                                </div>
                                <div v-if="props.item.type === 'LINE_EXPANDED'" @click="selectField(props.item.field)" style="padding-left: 20px; cursor: pointer;">
                                  {{ props.item.field.address.name }}
                                </div>
                                <div v-if="props.item.type === 'TOTAL'" class="subTotal">
                                  Total
                                </div>
                              </td>
                              <td class="text-xs-right amount" style="width: 100px !important; padding-right: 12px !important;">{{ props.item.amount.toLocaleString() }}</td>
                              <td></td>
                            </tr>
                          </template>
                        </v-data-table>
                      </template>
                    </Panel>
                  </v-flex>

                  <v-flex xs12 style="padding-top: 5px;" v-if="!filterFieldInactive">
                    <Panel no-margin="true" title="Prices" title-size="14px">
                      <v-data-table :headers="supplierPriceHeader" :items="prices" hide-actions v-if="prices.length && !editPrices" class="supplierPriceTable">
                        <template v-slot:items="props">
                          <tr>
                            <td style="width: 20px;"></td>
                            <td class="text-xs-left amount" style="width: 400px;">{{ props.item.category.displayLabel }}</td>
                            <td class="text-xs-right amount" style="width: 100px !important; padding-right: 12px !important;">{{ props.item.price ? props.item.price.toFixed(2) : '&#8212;' }}</td>
                            <td></td>
                            <td></td>
                          </tr>
                        </template>
                      </v-data-table>
                      <v-data-table :headers="supplierPriceHeader" :items="prices" hide-actions v-if="prices.length && editPrices" class="supplierPriceTable">
                        <template v-slot:items="props">
                          <tr>
                            <td style="width: 20px;"></td>
                            <td class="text-xs-left amount" style="width: 400px;">
                              <v-autocomplete :items="categories" v-model="props.item.category" item-text="displayLabel" return-object>
                                <template slot="selection" slot-scope="data">
                                  <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                                  <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                                  {{ data.item.displayLabel }}
                                </template>
                                <template slot="item" slot-scope="data">
                                  <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                                  <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                                  {{ data.item.displayLabel }}
                                </template>
                              </v-autocomplete>
                            </td>
                            <td class="text-xs-right amount" style="width: 100px !important; padding-right: 12px !important; padding-top: 5px !important;">
                              <v-text-field class="alignRight" color="teal" v-model="props.item.price" autocomplete="offit"/>
                            </td>
                            <td style="padding-top: 8px !important;">
                              <v-icon style="font-size: 16px;" @click="removePrice(props.index)">delete</v-icon>
                            </td>
                            <td></td>
                          </tr>
                        </template>
                      </v-data-table>
                      <v-flex xs12 v-if="!editPrices" style="padding-top: 10px;">
                        <div v-if="prices.length === 0" style="padding-bottom: 15px; font-style: italic;">No prices yet</div>
                        <v-btn flat @click="startEditPrices">Edit prices</v-btn>
                      </v-flex>
                      <v-flex xs12 text-xs-left v-if="editPrices" style="padding-top: 10px;">
                        <v-btn flat @click="addPrice">Add category</v-btn>
                        <v-btn flat @click="cancelPrices">Cancel</v-btn>
                        <v-btn flat @click="savePrices" :disabled="savePricesDisabled">Save</v-btn>
                      </v-flex>
                    </Panel>
                  </v-flex>

                  <v-flex xs12 v-show="supplierProductionForecastFoundations.length && !filterFieldInactive" style="padding-top: 5px;">
                    <Panel title="Production" no-margin="true" title-size="14px">
                      <v-data-table :headers="supplierProductionForecastFoundationHeader" :items="supplierProductionForecastFoundations" hide-actions class="forecastTable" v-if="supplierProductionForecastFoundations.length">
                        <template v-slot:items="props">
                          <tr :class="props.item.type === 'SUB_TOTAL' ? 'subTotal' : ''" v-if="props.item.displayYear || showProductionYear(props.item.year)">
                            <td class="text-xs-center amount" style="width: 100px !important; text-align: left !important;">
                              <div class="selectable" style="display: inline-block;" @click="toggleProductionYear(props.item.year)" v-if="props.item.displayYear">
                                <v-icon style="font-size: 16px;" v-if="!showProductionYear(props.item.year)">chevron_right</v-icon>
                                <v-icon style="font-size: 16px;" v-if="showProductionYear(props.item.year)">expand_more</v-icon>
                              </div>
                              <div class="selectable" style="display: inline-block;" @click="toggleProductionYear(props.item.year)" v-if="props.item.displayYear">
                                {{ props.item.year }}
                              </div>
                            </td>
                            <td class="text-xs-left amount" style="width: 300px;">
                              <div v-if="showProductionYear(props.item.year)">{{ props.item.category }}</div>
                              <div v-if="showProductionYear(props.item.year) && props.item.type === 'SUB_TOTAL'" class="subTotal">
                                Subtotal
                              </div>
                            </td>
                            <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;">
                              <div style="padding: 0 10px;" v-if="showProductionYear(props.item.year)">{{ props.item.amount.toLocaleString() }}</div>
                            </td>
                            <td class="text-xs-right amount" style="width: 150px !important; padding-right: 25px !important;">
                              <div style="padding: 0 10px;" v-if="showProductionYear(props.item.year)">{{ props.item.unitPrice ? formatNumber(props.item.unitPrice, 2) : '' }}</div>
                            </td>
                            <td class="text-xs-right amount" style="width: 120px !important;">
                              <div style="margin-right: -5px;" v-if="showProductionYear(props.item.year)">{{ props.item.price ? formatNumber(props.item.price, 2) : '' }}</div>
                            </td>
                            <td></td>
                          </tr>
                        </template>
                      </v-data-table>
                    </Panel>
                  </v-flex>
                </v-flex>
              </PanelColumn>
            </Panel>
            <Panel v-if="currentSupplier && !(currentField || currentPickupAddress) && supplierInformation">
              <PanelColumn title="Supplier">
                <v-flex xs4 md2>
                  <v-label>Name</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentSupplier.name" ref="name" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Supplier no.</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentSupplier.number" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>E-mail</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentSupplier.email" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>VAT no.</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentSupplier.vat" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Phone</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentSupplier.phone" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Mobile</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentSupplier.mobile" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Inactive</v-label>
                </v-flex>
                <v-flex xs8 md10>
                  <v-checkbox color="teal" v-model="currentSupplier.inactive"/>
                </v-flex>
                <v-flex xs12/>

                <v-flex xs4 md2 style="line-height: 35px;">
                  <v-label>Sales organization</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-select :items="salesOrganizations" v-model="currentSupplier.salesOrganization" item-text="name" return-object style="max-width: 300px;"></v-select>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                </v-flex>
                <v-flex xs8 md2>
                </v-flex>

                <v-flex xs4 md2 style="line-height: 35px;">
                  <v-label>Reference suppliers</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-select :items="referenceSuppliers" v-model="currentSupplier.referenceSuppliers" item-text="name" return-object multiple/>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                </v-flex>
                <v-flex xs8 md2>
                </v-flex>

                <v-flex xs4 md2 style="line-height: 35px;">
                  <v-label>Contractors</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-select :items="contractors" v-model="currentSupplier.contractors" item-text="name" return-object multiple/>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                </v-flex>
                <v-flex xs8 md2>
                </v-flex>

                <v-flex xs4 md2 style="line-height: 35px;">
                  <v-label>Loading address</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-select :items="pickupAddresses" v-model="currentSupplier.pickupAddress" return-object></v-select>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                </v-flex>
                <v-flex xs8 md2>
                </v-flex>
              </PanelColumn>

              <v-flex xs12 px-5 py-3 text-xs-center>
              </v-flex>

              <PanelColumn2 title="Address">
                <v-flex xs4 sm4>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.street" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.location" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.city" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.country" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs3 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.latitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs3 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.address.longitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.maps.addressToGeo(currentSupplier.address)" flat>Lookup geo code</v-btn>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentSupplier.address" ref="maps" height="285px"/>
              </PanelColumn2>

              <PanelColumn2 title="Default scrapping">
                <v-flex xs12>
                  <table>
                    <template v-for="(defaultScrap, i) in defaultScraps">
                      <tr :key="'ds_' + i">
                        <td>
                          <v-text-field color="teal" v-model="defaultScrap.age" autocomplete="offit" @keypress="keypressNumberField" style="max-width: 65px;" class="alignRight" maxlength="4" suffix="years"></v-text-field>
                        </td>
                        <td style="width: 12px;">&nbsp;</td>
                        <td>
                          <v-text-field color="teal" v-model="defaultScrap.value" autocomplete="offit" @keypress="keypressNumberField" style="max-width: 45px;" class="alignRight" maxlength="4" suffix="%"></v-text-field>
                        </td>
                        <td style="padding-left: 12px; padding-top: 2px; vertical-align: top;">
                          <v-icon style="font-size: 16px;" @click="removeDefaultScrap(i)">delete</v-icon>
                        </td>
                      </tr>
                    </template>
                  </table>
                </v-flex>
                <v-flex xs12>
                  <v-btn @click="addDefaultScrap()" flat>Add default scrapping</v-btn>
                </v-flex>
              </PanelColumn2>

              <PanelColumn2 title="Miscellaneous">
                <v-flex xs6>
                  <v-label>Minimum tree age for harvest</v-label>
                </v-flex>
                <v-flex xs6 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentSupplier.minTreeAgeForHarvest" autocomplete="offit" @keypress="keypressNumberField" style="max-width: 80px;" class="alignRight" maxlength="2" suffix="years"></v-text-field>
                </v-flex>
              </PanelColumn2>
            </Panel>

            <Panel v-if="currentSupplier && fields.length > 0 && !(currentField || currentPickupAddress) && supplierInformation">
              <PanelColumn title="Fields">
                <v-flex v-if="fields.length > 0" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                  <v-data-table :headers="fieldHeaders" :items="fields" hide-actions class="narrow">
                    <template v-slot:items="props">
                      <tr @click="selectField(props.item)" class="selectable supplierFields">
                        <td class="text-xs-left">{{ props.item.address.name }}</td>
                        <td class="text-xs-left">{{ props.item.address.street }}</td>
                        <td class="text-xs-left" style="width: 60px !important;">{{ props.item.address.houseNo }}</td>
                        <td class="text-xs-left" style="width: 200px !important;">{{ props.item.address.location }}</td>
                        <td class="text-xs-left" style="width: 100px !important;">{{ props.item.address.zipCode }}</td>
                        <td class="text-xs-left" style="width: 200px !important;">{{ props.item.address.city }}</td>
                        <td class="text-xs-left" style="width: 150px !important;">{{ props.item.address.country }}</td>
                        <td class="text-xs-left" style="width: 50px !important;">{{ props.item.inactive ? 'Yes' : 'No' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
          <v-flex style="overflow-y: auto; width: 100%;" v-if="currentSupplier && currentField && !currentPlanting">
            <Panel v-show="!fieldInformation && !fieldSummaryReady" min-height="350">
              <PanelColumn :title="currentField.address.name">
                Planting information is missing
              </PanelColumn>
            </Panel>
            <Panel v-show="!fieldInformation && fieldSummaryReady">
              <PanelColumn :title="currentField.address.name">
                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Year</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ fieldPlanting.year }}</div>
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Size</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ fieldPlanting.size.toFixed(2) }}</div> ha
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Planted amount</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ fieldPlanting.amount.toLocaleString() }}</div>
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldSummary" class="small">
                  <v-label>Field age</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldSummary" class="small">
                  <div class="fieldSummaryValue">{{ fieldSummary.fieldAge }}</div> yr
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Planted amount / ha</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ Math.round(fieldPlanting.amount / fieldPlanting.size).toLocaleString() }}</div>
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldSummary" class="small">
                  <v-label>Tree age</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldSummary" class="small">
                  <div class="fieldSummaryValue">{{ fieldSummary.plantAge }}</div> yr
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Remaining amount</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ getRemainingAmount(fieldPlanting) }}</div>
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Operational age</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ fieldPlanting.operationalAge }}</div> yr
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Remaining amount / ha</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ getRemainingAmount(fieldPlanting) ? Math.round(getRemainingAmount(fieldPlanting) / fieldPlanting.size).toLocaleString() : '' }}</div>
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                  <v-label>Utilization</v-label>
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                  <div class="fieldSummaryValue">{{ getUtilization(fieldPlanting) }}</div>%
                </v-flex>

                <v-flex xs12 sm2 px-2 v-if="fieldPlanting" class="small">
                </v-flex>
                <v-flex xs12 sm4 px-2 v-if="fieldPlanting" class="small">
                </v-flex>

                <v-flex xs12 px-2 v-if="fieldPlanting && fieldPlanting.comment && fieldPlanting.comment !== ''" class="small">
                  <v-label>Comment</v-label>
                </v-flex>
                <v-flex xs12 px-2 v-if="fieldPlanting && fieldPlanting.comment && fieldPlanting.comment !== ''" class="small">
                  <div style="white-space: pre-line;">{{ fieldPlanting.comment }}</div>
                </v-flex>

                <v-flex xs12 v-if="fieldForecastDatas && fieldForecastDatas.length" style="padding-top: 10px;">
                  <Panel no-margin="true">
                    <template v-for="(fieldForecastData, i) in fieldForecastDatas">
                      <v-flex xs12 class="panelTitle selectable" :style="i > 0 ? 'margin-top: 10px;' : ''" :key="'forecast_title_' + i" @click="toggleForecastYear(fieldForecastData[0].year)">
                        <v-icon style="font-size: 20px;" v-if="!showForecastYear(fieldForecastData[0].year)">chevron_right</v-icon>
                        <v-icon style="font-size: 20px;" v-if="showForecastYear(fieldForecastData[0].year)">expand_more</v-icon>
                        <div style="display: inline-block;">{{ 'Forecast ' + fieldForecastData[0].year }}</div>
                      </v-flex>
                      <v-data-table :headers="fieldForecastHeader" :items="fieldForecastData" hide-actions class="forecastTable" :key="'forecast_' + i + '_' + updateCounter" v-if="showForecastYear(fieldForecastData[0].year)">
                        <template v-slot:items="props">
                          <tr :class="props.item.type === 'TOTAL' ? 'subTotal' : ''" v-if="showForecastData(props.item)">
                            <td class="text-xs-left" style="width: 25px; padding-left: 5px !important; padding-right: 0 !important; padding-top: 1px !important; padding-bottom: 0 !important; line-height: 18px !important;'">
                              <v-icon style="font-size: 20px;" v-if="showExpandIcon(props.item)" @click="forecastFamilyClicked(props.item)">chevron_right</v-icon>
                              <v-icon style="font-size: 20px;" v-if="showCollapseIcon(props.item)" @click="forecastFamilyClicked(props.item)">expand_more</v-icon>
                            </td>
                            <td class="text-xs-left amount" style="width: 525px;">
                              <div v-if="props.item.type === 'LINE'" @click="forecastFamilyClicked(props.item)" style="cursor: pointer;">
                                {{ props.item.family.displayLabel }}
                              </div>
                              <div v-if="props.item.type === 'LINE_EXPANDED'" style="padding-left: 20px; white-space: nowrap;">
                                {{ props.item.field.address.name }} (season {{ props.item.forecastFoundation.productionYear }})
                              </div>
                              <div v-if="props.item.type === 'TOTAL'" class="subTotal">
                                Total
                              </div>
                            </td>
                            <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;" @click="props.item.type !== 'LINE_EXPANDED' ? props.item.removed ? null : props.item.type === 'TOTAL' ? createOrEditForecastTotalOverride(props.item) : createOrEditForecastOverride(props.item) : null" v-if="props.item.type !== 'LINE_EXPANDED'"><div style="padding: 0 10px; display: inline-block;" :class="(Number(activeProductionName) === fieldForecastData[0].year ? 'selectable' : '') + (props.item.override ? ' forecastAdjustment' : '')">{{ props.item.removed ? '' : props.item.amount.toLocaleString() }}</div></td>
                            <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;" @click="props.item.type === 'LINE_EXPANDED' ? createOrEditForecastAdjustment(props.item) : null" v-if="props.item.type === 'LINE_EXPANDED'"><div style="padding: 0 10px; display: inline-block;" :class="'selectable' + (hasAmountAdjustment(props.item) ? ' forecastAdjustment' : '')">{{ props.item.amount.toLocaleString() }}</div></td>
                            <td class="text-xs-right amount" style="width: 120px !important; padding-right: 15px !important;">{{ props.item.amountPerHa ? props.item.amountPerHa.toFixed(0) : '' }}</td>
                            <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;" v-if="props.item.type === 'LINE'"><div style="padding: 0 10px;">{{ props.item.removed ? '' : props.item.distribution.toFixed(1) + '%' }}</div></td>
                            <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;" v-if="props.item.type === 'LINE_EXPANDED'"></td>
                            <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;" v-if="props.item.type === 'TOTAL'"><div style="padding: 0 10px; display: inline-block;">100.0%</div></td>
                            <td class="text-xs-right amount" style="width: 50px !important; padding-right: 5px !important;" v-if="props.item.type === 'LINE'">
                              <div style="padding: 0 10px;"><v-icon v-if="canRemoveFamily(props.item)" style="font-size: 16px;" @click="removeFamily(props.item)" title="Remove forecast">delete</v-icon></div>
                              <div style="padding: 0 10px;"><v-icon v-if="canRestoreFamily(props.item)" style="font-size: 16px; color: #B0B0B0;" @click="restoreFamily(props.item)" title="Restore forecast">restore_from_trash</v-icon></div>
                            </td>
                            <td class="text-xs-right amount" style="width: 50px !important; padding-right: 5px !important;" v-if="props.item.type !== 'LINE'"></td>
                            <td></td>
                          </tr>
                        </template>
                      </v-data-table>
                      <v-flex :key="'fields_' + i" v-if="showForecastYear(fieldForecastData[0].year) && getForecastFoundations(fieldForecastData).length" style="padding-bottom: 12px;">
                        <v-label>Forecast fields</v-label>
                        <template v-for="(forecastFoundation, fy) in getForecastFoundations(fieldForecastData)">
                          <div :key="'forecastFoundation_' + fy" style="padding-left: 12px;">{{ forecastFoundation.field.address.name}} ({{ forecastFoundation.productionYear}})</div>
                        </template>
                      </v-flex>
                    </template>
                  </Panel>
                </v-flex>

                <v-flex xs12 v-show="fieldProductionForecastFoundations.length || fieldProductionCategoryForecastFoundations.length" style="padding-top: 5px;">
                  <Panel title="Production" no-margin="true" title-size="14px">
                    <v-flex text-xs-right xs12 style="margin-bottom: 10px;">
                      <v-btn flat @click="toggleProduction" class="bw-5">{{ showProductionByCategory ? 'Show families' : 'Show categories' }}</v-btn>
                    </v-flex>
                    <template v-for="(fieldProductionSeason, fps) in fieldProductionSeasons">
                      <v-flex xs12 class="small" :key="'fieldProductionSeason_' + fps">
                        <v-flex class="panelTitle" style="font-size: 13px; margin-left: 10px; margin-right: 12px;">Season {{ fieldProductionSeason.year }}</v-flex>
                        <div style="padding: 12px;">
                          <table class="productionIntro" style="margin-left: 10px; margin-bottom: 20px;">
                            <tr>
                              <td><v-label style="font-size: 13px;">Field age:</v-label></td>
                              <td style="text-align: right;">{{ fieldProductionSeason.fieldAge }}</td>
                              <td style="width: 100px;"></td>
                              <td><v-label style="font-size: 13px;" v-if="fieldProductionSeason.remainingAmount">Remaining amount:</v-label></td>
                              <td style="text-align: right;">{{ fieldProductionSeason.remainingAmount ? formatNumber(fieldProductionSeason.remainingAmount, 0) : '' }}</td>
                            </tr>
                            <tr>
                              <td><v-label style="font-size: 13px;">Tree age:</v-label></td>
                              <td style="text-align: right;">{{ fieldProductionSeason.treeAge }}</td>
                              <td style="width: 75px;"></td>
                              <td><v-label style="font-size: 13px;" v-if="fieldProductionSeason.utilization">Utilization:</v-label></td>
                              <td style="text-align: right;">{{ fieldProductionSeason.utilization ? fieldProductionSeason.utilization : ''}}</td>
                            </tr>
                          </table>

                          <v-data-table :headers="fieldProductionForecastFoundationHeader" :items="fieldProductionForecastFoundations" hide-actions class="forecastTable" v-if="fieldProductionForecastFoundations.length && !showProductionByCategory">
                            <template v-slot:items="props">
                              <tr :class="'TOTAL,SUB_TOTAL'.includes(props.item.type) ? 'subTotal' : ''" v-if="props.item.year === fieldProductionSeason.year">
                                <td class="text-xs-left amount" style="width: 300px;">
                                  {{ props.item.family.displayLabel }}
                                  <div v-if="props.item.type === 'SUB_TOTAL'" class="subTotal">
                                    Subtotal
                                  </div>
                                  <div v-if="props.item.type === 'TOTAL'" class="subTotal">
                                    Total
                                  </div>
                                </td>
                                <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;" @click="createOrEditForecastAdjustment(props.item)"><div style="padding: 0 10px; display: inline-block;" :class="'selectable' + (hasAmountAdjustment(props.item) ? ' forecastAdjustment' : '')">{{ props.item.amount.toLocaleString() }}</div></td>
                                <td class="text-xs-right amount" style="width: 120px !important; padding-right: 15px !important;">{{ props.item.amountPerHa ? props.item.amountPerHa.toFixed(0) : '' }}</td>
                                <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;" @click="createOrEditForecastAdjustment(props.item)"><div style="padding: 0 10px; display: inline-block;" :class="'selectable' + (hasPercentageAdjustment(props.item) ? ' forecastAdjustment' : '')">{{ props.item.percentage ? props.item.percentage.toFixed(2) + '%' : '' }}</div></td>
                                <td></td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-data-table :headers="fieldProductionCategoryForecastFoundationHeader" :items="fieldProductionCategoryForecastFoundations" hide-actions class="forecastTable" v-if="fieldProductionCategoryForecastFoundations.length && showProductionByCategory">
                            <template v-slot:items="props">
                              <tr :class="'TOTAL,SUB_TOTAL'.includes(props.item.type) ? 'subTotal' : ''" v-if="props.item.year === fieldProductionSeason.year">
                                <td class="text-xs-left amount" style="width: 300px;">
                                  {{ props.item.family }}
                                  <div v-if="props.item.type === 'SUB_TOTAL'" class="subTotal">
                                    Subtotal
                                  </div>
                                  <div v-if="props.item.type === 'TOTAL'" class="subTotal">
                                    Total
                                  </div>
                                </td>
                                <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;"><div style="padding: 0 10px;">{{ props.item.amount.toLocaleString() }}</div></td>
                                <td class="text-xs-right amount" style="width: 120px !important; padding-right: 15px !important;">{{ props.item.amountPerHa ? props.item.amountPerHa.toFixed(0) : '' }}</td>
                                <td class="text-xs-right amount" style="width: 120px !important; padding-right: 5px !important;"><div style="padding: 0 10px;">{{ props.item.percentage ? props.item.percentage.toFixed(2) + '%' : '' }}</div></td>
                                <td class="text-xs-right amount" style="width: 150px !important; padding-right: 25px !important;"><div style="padding: 0 10px;">{{ props.item.unitPrice ? formatNumber(props.item.unitPrice, 2) : '' }}</div></td>
                                <td class="text-xs-right amount" style="width: 120px !important;"><div style="margin-right: -5px;">{{ props.item.price ? formatNumber(props.item.price, 2) : '' }}</div></td>
                                <td></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </v-flex>
                    </template>
                    <v-flex xs12 style="margin-top: 20px;" v-show="fieldChartSeries.length">
                      <a-chart ref="fieldChart" height="600px" width="100%" :options="fieldChartOptions" :series="fieldChartSeries"></a-chart>
                    </v-flex>
                  </Panel>
                </v-flex>
              </PanelColumn>
            </Panel>
            <Panel v-if="fieldInformation">
              <PanelColumn2 title="Field address">
                <v-flex xs4 sm3>
                  <v-label>Name</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.name" ref="fieldName" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.street" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.location" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.city" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.address.country" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.address.latitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs2 sm1/>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.address.longitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.fmaps.addressToGeo(currentField.address)" flat>Lookup geo code</v-btn>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Inactive</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-checkbox color="teal" v-model="currentField.inactive"/>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Not statistic</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-checkbox color="teal" v-model="currentField.notStatistic"/>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentField.address" ref="fmaps" height="285px"/>
              </PanelColumn2>

              <PanelColumn2 title="Loading address">
                <v-flex xs4 sm3>
                  <v-label>Address</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-select :items="pickupAddresses" v-model="currentPickupAddressId" item-value="id" v-on:change="selectPickupAddress"></v-select>
                </v-flex>

                <div style="height: 36px;"/>

                <v-flex xs4 sm3>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.street" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.houseNo" style="width: 75px;" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.location" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.zipCode" style="width: 100px" :readonly="currentField.pickupAddress.id > 0"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.city" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.country" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.latitude" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs2 sm1/>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentField.pickupAddress.longitude" :readonly="currentField.pickupAddress.id > 0" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.pamaps.addressToGeo(currentField.pickupAddress)" flat>Lookup geo code</v-btn>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentField.pickupAddress" ref="pamaps" height="285px"/>
              </PanelColumn2>
            </Panel>
            <Panel v-if="fieldInformation && plantings.length > 0 && !currentPlanting">
              <PanelColumn title="Plantings">
                <v-flex v-if="plantings.length > 0" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                  <v-data-table :headers="plantingHeaders" :items="plantings" hide-actions class="narrow">
                    <template v-slot:items="props">
                      <tr @click="selectPlanting(props.item)" class="selectable">
                        <td class="text-xs-left" style="">{{ props.item.year }}</td>
                        <td class="text-xs-right" style="">{{ props.item.size + ' ha' }}</td>
                        <td class="text-xs-right" style="">{{ props.item.amount.toLocaleString() }}</td>
                        <td class="text-xs-right" style="">{{ props.item.amount > 0 && props.item.size > 0 ? Math.round(props.item.amount / props.item.size).toLocaleString() : '' }}</td>
                        <td class="text-xs-right" style="">{{ props.item.operationalAge + ' yr' }}</td>
                        <td class="text-xs-right" style="">{{ getUtilization(props.item) + '%' }}</td>
                        <td></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
          <v-flex style="overflow-y: auto; width: 100%;" v-if="currentSupplier && currentField && currentPlanting" class="planting">
            <Panel>
              <PanelColumnX width="6" title="Planting">
                <v-flex xs12 lg3>
                  <v-label>Year</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <v-text-field color="teal" v-model="currentPlanting.year" autocomplete="offit" type="number" style="max-width: 60px; display: inline-block; margin-right: 30px;" class="alignRight" maxlength="4" @keypress="keypressNumberField" @change="plantingYearChanged"></v-text-field>
                  <v-btn flat @click="seasonChanged('SPRING')" class="bw-2" v-if="currentPlanting.season === 'FALL'">Fall</v-btn>
                  <v-btn flat @click="seasonChanged('FALL')" class="bw-2" v-if="currentPlanting.season === 'SPRING'">Spring</v-btn>
                </v-flex>

                <v-flex xs12 lg3>
                  <v-label>Age</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <v-text-field color="teal" v-model="currentPlanting.age" autocomplete="offit" style="max-width: 60px;" class="alignRight" maxlength="2" @keypress="keypressNumberField" suffix="yr"></v-text-field>
                </v-flex>

                <v-flex xs12 lg3>
                  <v-label>Amount</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <v-text-field color="teal" v-model="currentPlanting.amount" autocomplete="offit" style="max-width: 60px;" class="alignRight" maxlength="6" @keypress="keypressNumberField"></v-text-field>
                </v-flex>

                <v-flex xs12 lg3>
                  <v-label>Size</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <v-text-field color="teal" v-model="currentPlanting.size" autocomplete="offit" style="max-width: 60px;" class="alignRight" maxlength="6" @keypress="keypressNumberFieldWithDecimals" suffix="ha"></v-text-field>
                </v-flex>

                <v-flex xs12 lg3>
                  <v-label>Operational age</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <v-text-field color="teal" v-model="currentPlanting.operationalAge" autocomplete="offit" style="max-width: 60px;" type="number" class="alignRight" maxlength="4" @keypress="keypressNumberField" suffix="yr" @change="operationalAgeChanged"></v-text-field>
                </v-flex>

                <v-flex xs12 lg3 style="height: 33px;">
                  <v-label>Utilization</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <div style="width: 60px; text-align: right; padding-top: 2px;">{{ utilization }}</div>
                </v-flex>

                <v-flex xs12 lg3>
                  <v-label>Provenance</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <v-text-field color="teal" v-model="currentPlanting.provenance" autocomplete="offit" style="max-width: 500px;"></v-text-field>
                </v-flex>

                <v-flex xs12 lg3>
                  <v-label>Supplier</v-label>
                </v-flex>
                <v-flex xs12 lg9>
                  <v-text-field color="teal" v-model="currentPlanting.supplier" autocomplete="offit" style="max-width: 500px;"></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-label>Comment</v-label>
                </v-flex>
                <v-flex xs12>
                  <v-textarea solo auto-grow flat rows="6" v-model="currentPlanting.comment" maxlength="1000"/>
                </v-flex>
              </PanelColumnX>
              <PanelColumnX width="3" title="Scrapping" inner-style="padding-top: 4px;">
                <template v-for="(scrap) in scraps">
                  <v-flex xs12 lg6 xl4 :key="'label_' + scrap.age" style="white-space: nowrap;">
                    <v-label>Field age {{ scrap.age }}</v-label>
                  </v-flex>
                  <v-flex xs12 lg6 xl8 :key="'value_' + scrap.age">
                    <v-text-field color="teal" v-model="scrap.value" autocomplete="offit" type="number" style="max-width: 45px;" class="alignRight" maxlength="4" suffix="%" @change="scrapChanged(scrap)"></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs12 lg6 xl4 style="white-space: nowrap;">
                  <v-label>Total</v-label>
                </v-flex>
                <v-flex xs12 lg6 xl8>
                  <div style="width: 45px; text-align: right; padding-top: 2px;">{{ totalScrapped }}</div>
                </v-flex>
              </PanelColumnX>
              <PanelColumnX width="3" title="Remaining amounts">
                <template v-for="(remaining) in remainings">
                  <v-flex xs12 lg6 xl4 :key="'label_' + remaining.production.id" style="white-space: nowrap;">
                    <v-label>{{ remaining.production.name }}</v-label>
                  </v-flex>
                  <v-flex xs12 lg6 xl8 :key="'value_' + remaining.production.id">
                    <v-text-field color="teal" v-model="remaining.amount" autocomplete="offit" type="number" style="max-width: 75px;" class="alignRight"></v-text-field>
                  </v-flex>
                </template>
                <v-btn flat v-if="remainings.length" :disabled="autoFillButtonDisabled" @click="autoFillRemainingAmounts" class="bw-3">Auto fill</v-btn>
              </PanelColumnX>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-0 px-0 v-if="showContract && !sendContractStarted">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Contract">
                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Number</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <div v-if="!currentContract.id" title="Next contract number" style="cursor: help;">
                    {{ currentContract.number }}<v-icon style="font-size: 10px; margin-left: 3px; margin-bottom: 3px;">star</v-icon>
                  </div>
                  <div v-if="currentContract.id">
                    {{ currentContract.number }}
                  </div>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Place of signature</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-text-field color="teal" v-model="currentContract.buyerSignaturePlace" style="max-width: 150px;" @change="contractDirty = true" @keyup="contractDirty = true"></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 lg2 style="height: 35px;">
                  <v-label>Signature date</v-label>
                </v-flex>
                <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                  <v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="currentContract.buyerSignatureDate" prepend-icon="event" readonly style="width: 120px;" v-on="on"/>
                    </template>
                    <v-date-picker v-model="currentContract.buyerSignatureDate" @input="dateMenu = false" @change="contractDirty = true"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12>
                  <v-label>Text</v-label>
                </v-flex>
                <v-flex xs12>
                  <v-textarea solo auto-grow flat rows="10" v-model="currentContract.contractText" @change="contractDirty = true" @keyup="contractDirty = true" style="width: 800px; max-width: 800px;"/>
                </v-flex>

                <div style="height: 15px;">&nbsp;</div>

                <v-flex xs12>
                  <v-label>Comments</v-label>
                </v-flex>
                <v-flex xs12>
                  <v-textarea solo auto-grow flat rows="3" v-model="currentContract.comment" maxlength="1000" @change="contractDirty = true" @keyup="contractDirty = true" style="max-width: 800px;"/>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentContract && sendContractStarted">
        <v-layout>
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Send contract">
                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>E-mail</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 style="height: 35px;">
                  <v-text-field color="teal" v-model="sendEmail" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>Subject</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg10 style="height: 35px;">
                  <v-text-field color="teal" v-model="sendSubject" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-label>Message</v-label>
                </v-flex>
                <v-flex xs12>
                  <wysiwyg v-model="sendMessage" class="approve-shipment"></wysiwyg>
                </v-flex>
                <v-flex xs12 style="padding-top: 10px;">
                  <v-label>Attachment:</v-label>
                  <div style="display: inline; font-weight: bold; margin-left: 30px; cursor: pointer; text-decoration: underline; font-size: 12px;" @click="printContract">Contract no. {{ currentContract.number }}.pdf</div>
                </v-flex>
                <v-flex xs12 style="padding-top: 10px;">
                  <v-btn flat @click="sendContract" :disabled="!sendEmailCorrect" class="bw-3" style="float: right;">Send</v-btn>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete supplier</v-card-title>
        <v-card-text v-if="currentSupplier">Are you sure you want to delete '{{ currentSupplier.name }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteSupplier">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteFieldDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete field</v-card-title>
        <v-card-text>Are you sure you want to delete this field?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteField">Yes</v-btn>
          <v-btn flat @click="confirmDeleteFieldDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeletePlantingDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete planting</v-card-title>
        <v-card-text>Are you sure you want to delete this planting?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deletePlanting">Yes</v-btn>
          <v-btn flat @click="confirmDeletePlantingDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="forecastAdjustmentDialog" persistent width="600">
      <v-card pa-5>
        <v-card-title class="headline">Adjust forecast</v-card-title>
        <v-card-text style="padding: 20px;">
          <table v-if="forecastAdjustmentDialog" style="width: 100%;">
            <tr>
              <td style="width: 200px;"><v-label>Production year</v-label></td>
              <td style="padding-right: 30px;">{{ forecastAdjustment.production.name }}</td>
            </tr>
            <tr>
              <td style="width: 200px;"><v-label>Field</v-label></td>
              <td style="padding-right: 30px;">{{ forecastAdjustment.field.address.name }}</td>
            </tr>
            <tr>
              <td style="width: 200px;"><v-label>Category family</v-label></td>
              <td style="padding-right: 30px;">{{ forecastAdjustment.family.displayLabel }}</td>
            </tr>
            <tr>
              <td style="width: 200px;"><v-label>Amount</v-label></td>
              <td style="padding-right: 30px;">
                <table>
                  <tr>
                    <td style="width: 70px;">
                      <v-text-field class="alignRight" color="teal" v-model="forecastAdjustment.amount" autocomplete="offit" @keyup="forecastAdjustment.percentage = ''" :readonly="forecastAdjustment.disabled"/>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width: 200px;"><v-label>Percentage</v-label></td>
              <td style="padding-right: 30px;">
                <table>
                  <tr>
                    <td style="width: 70px;">
                      <v-text-field class="alignRight" color="teal" v-model="forecastAdjustment.percentage" autocomplete="offit" @keyup="forecastAdjustment.amount = ''" :readonly="forecastAdjustment.disabled"/>
                    </td>
                    <td style="padding-top: 3px; padding-left: 5px; vertical-align: top;">%</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width: 200px;"><v-label>Disabled</v-label></td>
              <td style="padding-right: 30px;">
                <table>
                  <tr>
                    <td style="width: 100px;">
                      <v-checkbox color="teal" v-model="forecastAdjustment.disabled" @change="forecastAdjustmentDisabledChanged"/>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="2"><v-label>Comment</v-label></td>
            </tr>
            <tr>
              <td colspan="2">
                <v-textarea solo auto-grow flat rows="6" v-model="forecastAdjustment.comment" maxlength="1000"/>
              </td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="saveForecastAdjustment" :disabled="saveForecastAdjustmentButtonDisabled">Save</v-btn>
          <v-btn flat @click="deleteForecastAdjustment" v-if="forecastAdjustment && forecastAdjustment.id">Delete</v-btn>
          <v-btn flat @click="cancelForecastAdjustment">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="forecastOverrideDialog" persistent width="600">
      <v-card pa-5>
        <v-card-title class="headline">Override forecast</v-card-title>
        <v-card-text style="padding: 20px;">
          <table v-if="forecastOverrideDialog" style="width: 100%;">
            <tr>
              <td style="width: 200px;"><v-label>Category family</v-label></td>
              <td style="padding-right: 30px;">{{ forecastOverride.family.displayLabel }}</td>
            </tr>
            <tr>
              <td style="width: 200px;"><v-label>Amount</v-label></td>
              <td style="padding-right: 30px;">
                <table>
                  <tr>
                    <td style="width: 70px;">
                      <v-text-field class="alignRight" color="teal" v-model="forecastOverride.amount" autocomplete="offit"/>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="saveForecastOverride" :disabled="saveForecastOverrideButtonDisabled">Save</v-btn>
          <v-btn flat @click="deleteForecastOverride" v-if="forecastOverrideDeletable">Delete</v-btn>
          <v-btn flat @click="cancelForecastOverride">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="forecastTotalOverrideDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Override forecast total </v-card-title>
        <v-card-text style="padding: 20px;">
          <table v-if="forecastTotalOverrideDialog" style="width: 100%;">
            <tr>
              <td style="width: 140px; padding-left: 40px;"><v-label>Amount</v-label></td>
              <td style="padding-right: 30px;">
                <table>
                  <tr>
                    <td style="width: 90px;">
                      <v-text-field class="alignRight" color="teal" v-model="forecastTotalOverride.amount" autocomplete="offit"/>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="saveForecastTotalOverride" :disabled="saveForecastTotalOverrideButtonDisabled">Save</v-btn>
          <v-btn flat @click="deleteForecastTotalOverride" v-if="forecastTotalOverrideDeletable">Delete</v-btn>
          <v-btn flat @click="cancelForecastTotalOverride">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="scrapChangedCurrentYearDialog" persistent width="600">
      <v-card pa-5>
        <v-card-title class="headline">Update remaining amount</v-card-title>
        <v-card-text style="padding: 20px;">Do you want to update the remaining amount for this field?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="autoFillRemainingAmountsCurrentYear">Yes</v-btn>
          <v-btn flat @click="scrapChangedCurrentYearDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">{{errorTitle && errorTitle !== '' ? errorTitle : 'Error'}}</v-card-title>
        <v-card-text>{{errorMessage}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteContractDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete contract</v-card-title>
        <v-card-text v-if="currentContract">Are you sure you want to delete this contract?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteContract">Yes</v-btn>
          <v-btn flat @click="confirmDeleteContractDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import Maps from '../components/Maps'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import PanelColumn3 from '../components/PanelColumn3'
import PanelColumnX from '../components/PanelColumnX'
import Headline from '../components/Headline'
import axios from 'axios'
import uuid from 'uuid/v4'
import AChart from 'vue-apexcharts'
import NumberUtil from '@/assets/javascript/numberutil'
import ScrapUtil from '@/assets/javascript/scraputil'
import DateUtil from '@/assets/javascript/dateutil'
import { mapGetters } from 'vuex'

export default {
  name: 'Suppliers',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, PanelColumn3, PanelColumnX, Headline, Maps, AChart },
  data () {
    return {
      filterSuppliers: [],
      filterSupplierList: [],
      filterFields: [],
      filterFieldList: [],
      filterProductions: [],
      filterProductionList: [],
      statisticsColumns: [],
      statisticsColumnList: [],
      otherFilterSupplierList: [],
      otherFilterFieldList: [],
      otherFilterProductionList: [],
      pagination: {
        rowsPerPage: -1,
        sortBy: 'size',
        descending: true
      },
      paginationInactive: {
        rowsPerPage: -1,
        sortBy: 'name',
        descending: false
      },
      paginationSupplierFields: {
        rowsPerPage: -1,
        sortBy: 'plantAge',
        descending: true
      },
      headers: [
        { text: 'Number', value: 'number', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Size', value: 'size', sortable: true, align: 'center' },
        { text: 'Adj. forecast', value: 'forecast', sortable: true, align: 'center' },
        { text: 'Harvest area', value: 'harvestSize', sortable: true, align: 'center' },
        { text: '', value: '', sortable: false }
      ],
      headersInactive: [
        { text: 'Number', value: 'number', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: '', value: '', sortable: false }
      ],
      fieldHeaders: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Street', value: 'street', sortable: false },
        { text: 'No.', value: 'houseNo', sortable: false },
        { text: 'Location', value: 'location', sortable: false },
        { text: 'Postal code', value: 'zipCode', sortable: false },
        { text: 'City', value: 'city', sortable: false },
        { text: 'Country', value: 'country', sortable: false },
        { text: 'Inactive', value: 'inactive', sortable: false }
      ],
      plantingHeaders: [
        { text: 'Year', value: 'year', sortable: false },
        { text: 'Size', value: 'size', sortable: false, align: 'end' },
        { text: 'Amount', value: 'amount', sortable: false, align: 'end' },
        { text: 'Amount / ha', value: 'amount/size', sortable: false, align: 'end' },
        { text: 'Operational age', value: 'operationalAge', sortable: false, align: 'end' },
        { text: 'Utilization', value: 'utilization', sortable: false, align: 'end' },
        { text: '', value: '', sortable: false }
      ],
      palletHeaders: [
        { text: 'Pallet no.', value: 'number', sortable: true },
        { text: 'Ext. pallet no.', value: 'number', sortable: true },
        { text: 'State', value: 'state', sortable: true },
        { text: 'Field', value: 'field.address.nameAndText', sortable: true },
        { text: 'Category', value: 'categoriesText', sortable: true }
      ],
      deliveryReportHeaders: [
        { text: '', sortable: false },
        { text: 'Category', value: 'category.displayLabel', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false, align: 'right' }
      ],
      fieldForecastHeader: [
        { text: '', sortable: false, align: 'left' },
        { text: 'Category family', sortable: false, align: 'left' },
        { text: 'Amount', sortable: false, align: 'right' },
        { text: 'Amount / ha', sortable: false, align: 'right' },
        { text: 'Distribution', sortable: false, align: 'right' },
        { text: '', sortable: false, align: 'left' },
        { text: '', sortable: false, align: 'left' }
      ],
      supplierForecastHeader: [
        { text: '', sortable: false, align: 'left' },
        { text: 'Category family', sortable: false, align: 'left' },
        { text: 'Amount', sortable: false, align: 'right' },
        { text: '', sortable: false, align: 'left' }
      ],
      supplierPriceHeader: [
        { text: '', sortable: false, align: 'left' },
        { text: 'Category', sortable: false },
        { text: 'Price', sortable: false, align: 'right' },
        { text: '', sortable: false, align: 'left' },
        { text: '', sortable: false, align: 'left' }
      ],
      supplierProductionForecastFoundationHeader: [
        { text: 'Season', sortable: false, align: 'center' },
        { text: 'Category', sortable: false },
        { text: 'Amount', sortable: false, align: 'right' },
        { text: 'Price / category', sortable: false, align: 'right' },
        { text: 'Price', sortable: false, align: 'right' },
        { text: '', sortable: false, align: 'left' }
      ],
      supplierProductionCategoryForecastFoundationHeader: [
        { text: 'Season', sortable: false, align: 'center' },
        { text: 'Category', sortable: false },
        { text: 'Amount', sortable: false, align: 'right' },
        { text: 'Amount / ha', sortable: false, align: 'right' },
        { text: 'Utilized', sortable: false, align: 'right' },
        { text: '', sortable: false, align: 'left' }
      ],
      fieldProductionForecastFoundationHeader: [
        { text: 'Category family', sortable: false },
        { text: 'Amount', sortable: false, align: 'right' },
        { text: 'Amount / ha', sortable: false, align: 'right' },
        { text: 'Quality %', sortable: false, align: 'right' },
        { text: '', sortable: false, align: 'left' }
      ],
      fieldProductionCategoryForecastFoundationHeader: [
        { text: 'Category', sortable: false },
        { text: 'Amount', sortable: false, align: 'right' },
        { text: 'Amount / ha', sortable: false, align: 'right' },
        { text: 'Quality %', sortable: false, align: 'right' },
        { text: 'Price / category', sortable: false, align: 'right' },
        { text: 'Price', sortable: false, align: 'right' },
        { text: '', sortable: false, align: 'left' }
      ],
      supplierFieldSummaryHeader: [
        { text: 'Field', value: 'field.address.name', sortable: false, align: 'left' },
        { text: 'Year', value: 'planting.year', sortable: false, align: 'center' },
        { text: 'Size', value: 'planting.size', sortable: false, align: 'right' },
        { text: 'Planted amount', value: 'planting.amount', sortable: false, align: 'right' },
        { text: 'Planted amount / ha', value: 'amountPerHa', sortable: false, align: 'right' },
        { text: 'Remaining amount', value: 'amountRemaining', sortable: false, align: 'right' },
        { text: 'Remaining amount / ha', value: 'amountRemainingPerHa', sortable: false, align: 'right' },
        { text: 'Adj. forecast', value: 'forecast', sortable: false, align: 'right' },
        { text: 'Adj. forecast / ha', value: 'forecastPerHa', sortable: false, align: 'right' },
        { text: 'Field age', value: 'fieldAge', sortable: false, align: 'right' },
        { text: 'Tree age', value: 'plantAge', sortable: false, align: 'right' },
        { text: 'Operational age', value: 'planting.operationalAge', sortable: false, align: 'right' },
        { text: 'Utilization', sortable: false, align: 'right' }
      ],
      fieldSummaryOptions: {
        xaxis: {
          categories: []
        },
        stroke: {
          curve: 'smooth'
        },
        chart: {
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          }
        },
        tooltip: {
          enabled: false
        },
        states: {
          hover: {
            filter: {
              type: 'none'
            }
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'left'
        }
      },
      chartFieldSummary: null,
      fieldSummaryKey: 1,
      suppliers: [],
      fields: [],
      plantings: [],
      labelledProductions: [],
      plantingAmountRemaining: [],
      contractors: [],
      categories: [],
      pickupAddresses: [],
      salesOrganizations: [],
      showStatistics: false,
      showStatisticsCompare: false,
      statistics: null,
      otherStatistics: null,
      currentSupplier: null,
      supplierInformation: false,
      currentField: null,
      fieldInformation: false,
      currentPickupAddress: null,
      currentPickupAddressId: 0,
      currentPlanting: null,
      defaultScraps: [],
      scraps: [],
      remainings: [],
      confirmDeleteDialog: false,
      confirmDeleteFieldDialog: false,
      confirmDeletePlantingDialog: false,
      errorDialog: false,
      errorTitle: '',
      errorMessage: '',
      showProduction: false,
      pallets: [],
      showDeliveryReport: false,
      deliveryReport: null,
      filterInactive: false,
      suppliersFieldChartSummary: [],
      suppliersFieldChartMinPlantAge: -1,
      suppliersFieldChartMaxPlantAge: -1,
      supplierFieldSummaryReady: false,
      filterFieldInactive: false,
      supplierFieldSummaryData: [],
      fieldSummaryReady: false,
      fieldSummary: null,
      fieldForecastFoundations: [],
      supplierProductionForecastFoundations: [],
      fieldProductionForecastFoundations: [],
      fieldProductionCategoryForecastFoundations: [],
      showProductionByCategory: true,
      fieldPlanting: null,
      fieldForecastDatas: null,
      supplierForecastDatas: null,
      expandedFamilies: new Map(),
      forecastAdjustmentDialog: false,
      forecastAdjustment: null,
      forecastOverrideDialog: false,
      forecastOverride: null,
      forecastOverrideDeletable: false,
      forecastTotalOverrideDialog: false,
      forecastTotalOverride: null,
      forecastTotalOverrideDeletable: false,
      scrapChangedCurrentYearDialog: false,
      showForecastYears: {},
      showProductionYears: {},
      prices: [],
      editPrices: false,
      expandedStatistics: {},
      contract: null,
      contractLoaded: false,
      currentContract: null,
      contractDirty: false,
      sendContractStarted: false,
      sendEmail: '',
      sendSubject: '',
      sendMessage: '',
      confirmDeleteContractDialog: false,
      dateMenu: false,
      updateCounter: 1
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'suppliers' })
    this.loadSuppliers()
    this.loadContractors()
    this.loadCategories()
    this.loadFilterSuppliers()
    this.loadFilterFields()
    this.loadFilterProductions()
    this.loadSupplierFieldChartSummaries()
  },
  computed: {
    users: function () {
      return this.$store.state.user.users
    },
    saveButtonDisabled: function () {
      return !this.currentSupplier || this.currentSupplier.name.trim() === '' || this.currentSupplier.number.trim() === '' || !this.currentSupplier.salesOrganization
    },
    saveFieldButtonDisabled: function () {
      return !this.currentField || (this.currentField.address.street.trim() === '' && this.currentField.address.houseNo.trim() === '' && this.currentField.address.location.trim() === '' && this.currentField.address.zipCode.trim() === '' && this.currentField.address.city.trim() === '' && this.currentField.address.country.trim() === '' && this.currentField.address.latitude.trim() === '' && this.currentField.address.longitude.trim() === '') || (this.currentField.pickupAddress.street.trim() === '' && this.currentField.pickupAddress.houseNo.trim() === '' && this.currentField.pickupAddress.location.trim() === '' && this.currentField.pickupAddress.zipCode.trim() === '' && this.currentField.pickupAddress.city.trim() === '' && this.currentField.pickupAddress.country.trim() === '' && this.currentField.pickupAddress.latitude.trim() === '' && this.currentField.pickupAddress.longitude.trim() === '')
    },
    savePlantingButtonDisabled: function () {
      return false
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterFieldActive () {
      return (this.filterFieldInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterFieldInactive () {
      return (this.filterFieldInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredSuppliers () {
      return this.suppliers.filter(sup => (this.filterSupplierList.length === 0 || this.filterSupplierList.filter(s => s.id === sup.id).length) && (this.filterInactive ? sup.inactive : !sup.inactive))
    },
    referenceSuppliers () {
      let referenceSuppliers = []
      referenceSuppliers.push({
        id: null,
        name: ''
      })
      if (this.suppliers) {
        for (let supplier of this.suppliers) {
          if (this.currentSupplier && this.currentSupplier.id === supplier.id) {
            continue
          }
          referenceSuppliers.push(supplier)
        }
      }
      return referenceSuppliers
    },
    saveForecastAdjustmentButtonDisabled () {
      if (this.forecastAdjustment) {
        if (this.forecastAdjustment.amount) {
          return !NumberUtil.isZeroOrPositiveInteger(this.forecastAdjustment.amount)
        } else if (this.forecastAdjustment.percentage) {
          return !NumberUtil.isZeroOrPositiveNumber(this.forecastAdjustment.percentage)
        } else if (this.forecastAdjustment.disabled) {
          return false
        }
      }
      return true
    },
    saveForecastOverrideButtonDisabled () {
      if (this.forecastOverride) {
        if (this.forecastOverride.amount) {
          return !NumberUtil.isZeroOrPositiveInteger(this.forecastOverride.amount)
        }
      }
      return true
    },
    saveForecastTotalOverrideButtonDisabled () {
      if (this.forecastTotalOverride) {
        if (this.forecastTotalOverride.amount) {
          return !NumberUtil.isZeroOrPositiveInteger(this.forecastTotalOverride.amount)
        }
      }
      return true
    },
    savePricesDisabled () {
      for (let supplierPrice of this.prices) {
        if (!supplierPrice.category || !supplierPrice.category.id) {
          return true
        }
        if (this.prices.filter(sp => sp.category && sp.category.id === supplierPrice.category.id).length > 1) {
          return true
        }
        if (!NumberUtil.isPositiveNumber(supplierPrice.price)) {
          return true
        }
      }
      return false
    },
    hasActiveProduction: function () {
      return this.$store.getters['session/hasActiveProduction']
    },
    activeProductionName: function () {
      return this.hasActiveProduction ? this.$store.getters['session/getActiveProduction'].name : ''
    },
    totalScrapped: function () {
      return NumberUtil.format(new ScrapUtil().getTotal(this.scraps), 1) + ' %'
    },
    utilization: function () {
      return NumberUtil.format(new ScrapUtil().getUtilization(this.scraps), 1) + ' %'
    },
    autoFillButtonDisabled: function () {
      let disabled = true
      if (!this.scrapChangedCurrentYearDialog && this.currentPlanting && this.currentPlanting.amount && this.currentPlanting.operationalAge && this.remainings && this.remainings.length) {
        for (let remaining of this.remainings) {
          if (!remaining.amount || remaining.amount === '' || remaining.amount === 0 || remaining.amount === '0') {
            disabled = false
            break
          }
        }
      }
      return disabled
    },
    supplierChartOptions: function () {
      let options = {
        colors: [
          '#4040AD',
          '#004D40',
          '#7D7D40',
          '#AD4040',
          '#8080DD',
          '#007D70',
          '#ADAD40',
          '#DD7070',
          '#B0B0FF',
          '#50AD88',
          '#DDDD60',
          '#FFA0A0'
        ],
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          }
        },
        dataLabels: {
          style: {
            fontSize: '10px',
            colors: ['#FFFFFF']
          },
          formatter: (val) => {
            return NumberUtil.format(val, 1) + ' ha'
          }
        },
        xaxis: {
          categories: []
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '11px',
                  fontWeight: 900
                },
                formatter: function (val) {
                  return NumberUtil.format(val, 1) + ' ha'
                }
              }
            }
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val) => {
              return NumberUtil.format(val, 1) + ' ha'
            }
          }
        }
      }

      if (this.suppliersFieldChartMinPlantAge > 0 && this.suppliersFieldChartMaxPlantAge >= this.suppliersFieldChartMinPlantAge) {
        for (let treeAge = this.suppliersFieldChartMinPlantAge; treeAge <= this.suppliersFieldChartMaxPlantAge; treeAge++) {
          options.xaxis.categories.push(treeAge + ' years')
        }
      }

      return options
    },
    supplierChartSeries: function () {
      let series = []
      if (this.suppliersFieldChartSummary) {
        for (let supplierFieldChartSummary of this.suppliersFieldChartSummary) {
          if (supplierFieldChartSummary.fieldSummaries && supplierFieldChartSummary.fieldSummaries.length && (this.filterSupplierList.length === 0 || this.filterSupplierList.filter(s => s.id === supplierFieldChartSummary.supplier.id).length)) {
            let sizes = {}
            for (let treeAge = this.suppliersFieldChartMinPlantAge; treeAge <= this.suppliersFieldChartMaxPlantAge; treeAge++) {
              sizes[treeAge] = 0
            }
            for (let fieldSummary of supplierFieldChartSummary.fieldSummaries) {
              let size = sizes[fieldSummary.plantAge]
              size += fieldSummary.size
              sizes[fieldSummary.plantAge] = size
            }
            let serie = {
              name: supplierFieldChartSummary.supplier.name,
              data: []
            }
            for (let i in sizes) {
              serie.data.push(NumberUtil.format(sizes[i], 1))
            }
            series.push(serie)
          }
        }
      }
      return series
    },
    fieldChartOptions: function () {
      let options = {
        colors: [
          '#4040AD',
          '#004D40',
          '#7D7D40',
          '#AD4040',
          '#8080DD',
          '#007D70',
          '#ADAD40',
          '#DD7070',
          '#B0B0FF',
          '#50AD88',
          '#DDDD60',
          '#FFA0A0'
        ],
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          }
        },
        dataLabels: {
          style: {
            fontSize: '10px',
            colors: ['#FFFFFF']
          },
          formatter: (val) => {
            return this.formatNumber(val, 0)
          }
        },
        xaxis: {
          categories: []
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '11px',
                  fontWeight: 900
                },
                formatter: (val) => {
                  return this.formatNumber(val, 0)
                }
              }
            }
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val) => {
              return this.formatNumber(val, 0)
            }
          }
        }
      }

      if (this.chartFieldSummary && this.chartFieldSummary.years && this.chartFieldSummary.years.length) {
        for (let year of this.chartFieldSummary.years) {
          options.xaxis.categories.push(year)
        }
      }

      return options
    },
    fieldChartSeries: function () {
      let series = []

      if (this.chartFieldSummary) {
        if (this.showProductionByCategory) {
          let qualities = []
          let categories = this.chartFieldSummary.categories
          categories.sort(function (c1, c2) {
            return c1.sortableLabel.localeCompare(c2.sortableLabel)
          })
          for (let category of categories) {
            if (qualities.filter(q => q === category.quality).length === 0) {
              qualities.push(category.quality)
            }
          }

          for (let quality of qualities) {
            let serie = {
              name: quality,
              data: []
            }
            for (let y = 0; y < this.chartFieldSummary.years.length; y++) {
              let qualitySum = 0
              for (let c = 0; c < this.chartFieldSummary.categories.length; c++) {
                if (this.chartFieldSummary.categories[c].quality === quality) {
                  qualitySum += this.chartFieldSummary.labelledCategoryAmount[this.chartFieldSummary.categories[c].id][y]
                }
              }
              serie.data.push(qualitySum)
            }
            series.push(serie)
          }
        } else {
          let qualities = []
          let families = this.chartFieldSummary.families
          families.sort(function (f1, f2) {
            return f1.sortableLabel.localeCompare(f2.sortableLabel)
          })
          for (let family of families) {
            if (qualities.filter(q => q === family.quality).length === 0) {
              qualities.push(family.quality)
            }
          }

          for (let quality of qualities) {
            let serie = {
              name: quality,
              data: []
            }
            for (let y = 0; y < this.chartFieldSummary.years.length; y++) {
              let qualitySum = 0
              for (let f = 0; f < this.chartFieldSummary.families.length; f++) {
                if (this.chartFieldSummary.families[f].quality === quality) {
                  qualitySum += this.chartFieldSummary.labelledAmount[this.chartFieldSummary.families[f].id][y]
                }
              }
              serie.data.push(qualitySum)
            }
            series.push(serie)
          }
        }
      }
      return series
    },
    filteredSupplierFieldSummaryData: function () {
      if (!this.supplierFieldSummaryData || this.supplierFieldSummaryData.length === 0) {
        return []
      }
      let totalSize = 0
      let totalAmountRemaining = 0
      let totalAmount = 0
      let totalForecast = 0

      let lastPlantAge = null
      let size = 0
      let amountRemaining = 0
      let amount = 0
      let forecast = 0

      let supplierFieldSummaryData = []
      for (let fieldSummary of this.supplierFieldSummaryData) {
        if (fieldSummary.field.inactive !== this.filterFieldInactive) {
          continue
        }
        if (lastPlantAge && fieldSummary.plantAge !== lastPlantAge) {
          // Add a sub total
          supplierFieldSummaryData.push({
            type: 'subTotal',
            field: '',
            amount: amount,
            amountPerHa: amount ? Math.round(amount / size) : null,
            size: size,
            plantAge: lastPlantAge,
            amountRemaining: amountRemaining,
            amountRemainingPerHa: size ? Math.round(amountRemaining / size) : null,
            forecast: forecast,
            forecastPerHa: forecast ? Math.round(forecast / size) : null
          })
          size = 0
          amount = 0
          amountRemaining = 0
          forecast = 0
        }

        if (fieldSummary.planting) {
          totalSize += fieldSummary.planting.size
          totalAmount += fieldSummary.planting.amount
          size += fieldSummary.planting.size
          amount += fieldSummary.planting.amount
        }
        totalAmountRemaining += fieldSummary.amountRemaining
        amountRemaining += fieldSummary.amountRemaining
        forecast += fieldSummary.forecast
        totalForecast += fieldSummary.forecast

        supplierFieldSummaryData.push({
          type: 'field',
          field: fieldSummary.field,
          planting: fieldSummary.planting,
          plantAge: fieldSummary.plantAge,
          fieldAge: fieldSummary.fieldAge,
          amountPerHa: fieldSummary.planting ? Math.round(fieldSummary.planting.amount / fieldSummary.planting.size) : null,
          amountRemaining: fieldSummary.amountRemaining,
          amountRemainingPerHa: fieldSummary.planting ? Math.round(fieldSummary.amountRemaining / fieldSummary.planting.size) : null,
          forecast: fieldSummary.forecast,
          forecastPerHa: fieldSummary.forecastPerHa
        })

        lastPlantAge = fieldSummary.plantAge
      }

      if (lastPlantAge) {
        // Add last sub total
        supplierFieldSummaryData.push({
          type: 'subTotal',
          field: '',
          amount: amount,
          amountPerHa: amount ? Math.round(amount / size) : null,
          size: size,
          plantAge: lastPlantAge,
          amountRemaining: amountRemaining,
          amountRemainingPerHa: size ? Math.round(amountRemaining / size) : null,
          forecast: forecast,
          forecastPerHa: forecast ? Math.round(forecast / size) : null
        })
      }

      // Add total
      supplierFieldSummaryData.push({
        type: 'total',
        field: '',
        amount: totalAmount,
        amountPerHa: totalAmount ? Math.round(totalAmount / totalSize) : null,
        size: totalSize,
        amountRemaining: totalAmountRemaining,
        amountRemainingPerHa: totalSize ? Math.round(totalAmountRemaining / totalSize) : null,
        forecast: totalForecast,
        forecastPerHa: totalSize ? Math.round(totalForecast / totalSize) : null
      })

      return supplierFieldSummaryData
    },
    fieldProductionSeasons: function () {
      let seasons = []
      if (this.fieldProductionForecastFoundations && this.fieldProductionForecastFoundations.length) {
        for (let fieldProductionForecastFoundation of this.fieldProductionForecastFoundations) {
          if (fieldProductionForecastFoundation.year && fieldProductionForecastFoundation.year !== '') {
            if (seasons.length && seasons[seasons.length - 1].year === fieldProductionForecastFoundation.year) {
              continue
            }
            let remainingAmount = null
            let productionId = fieldProductionForecastFoundation.forecastFoundation.productionId
            for (let remaining of fieldProductionForecastFoundation.forecastFoundation.planting.remainings) {
              if (remaining.production.id === productionId) {
                remainingAmount = remaining.amount
                break
              }
            }
            let utilization = null
            if (remainingAmount && fieldProductionForecastFoundation.forecastFoundation.totalCategoryAmount) {
              utilization = (fieldProductionForecastFoundation.forecastFoundation.totalCategoryAmount * 100 / remainingAmount).toFixed(1) + '%'
            }
            let season = {
              year: fieldProductionForecastFoundation.year,
              fieldAge: (fieldProductionForecastFoundation.age - fieldProductionForecastFoundation.forecastFoundation.planting.age) + ' yr',
              treeAge: fieldProductionForecastFoundation.age + ' yr',
              remainingAmount: remainingAmount,
              utilization: utilization
            }
            seasons.push(season)
          }
        }
      }
      return seasons
    },
    statisticQualities: function () {
      let qualities = []
      if (this.statistics && this.statistics.length) {
        for (let stat of this.statistics) {
          if (stat.labelledByQuality) {
            for (let labelledByQuality in stat.labelledByQuality) {
              if (!qualities.includes(labelledByQuality)) {
                qualities.push(labelledByQuality)
              }
            }
          }
        }
        qualities.sort()
      }
      return qualities
    },
    statisticHeaders: function () {
      let headers = []
      if (this.showStatisticsField) {
        headers.push({ text: '', sortable: false, align: 'left' })
      }
      headers.push({ text: 'Tree age', sortable: false, align: 'left' })
      if (this.showStatisticsColum('SIZE')) {
        headers.push({ text: 'Size', sortable: false, align: 'end' })
      }
      if (this.showStatisticsColum('PLANTED_AMOUNT')) {
        headers.push({ text: 'Planted amount', sortable: false, align: 'end' })
      }
      if (this.showStatisticsColum('HARVEST_YEAR') && !this.showStatisticsCompare && this.isAnyStatisticExpanded) {
        headers.push({ text: 'Harvest year', sortable: false, align: 'center' })
      }
      if (this.showStatisticsColum('HARVEST_PERCENTAGE')) {
        headers.push({ text: 'Harvest %', sortable: false, align: 'end' })
      }
      if (this.showStatisticsColum('AMOUNT')) {
        headers.push({ text: 'Amount', sortable: false, align: 'end' })
      }
      if (this.showStatisticsColum('AMOUNT_PER_HA')) {
        headers.push({ text: 'Amount / ha', sortable: false, align: 'end' })
      }
      for (let quality of this.statisticQualities) {
        if (this.showStatisticsColum('QUALITY_' + quality)) {
          headers.push({
            text: quality,
            sortable: false,
            align: 'end'
          })
        }
      }
      headers.push({
        text: '',
        sortable: false
      })
      return headers
    },
    getStatisticsQualityColumnWidth: function () {
      let showLabelledAmount = this.statisticsColumnList.filter(sc => sc.type === 'LABELLED_AMOUNT').length ? 100 : 0
      let showLabelledPercentage = this.statisticsColumnList.filter(sc => sc.type === 'LABELLED_PERCENTAGE').length ? 60 : 0
      if (showLabelledAmount && showLabelledPercentage) {
        return 140
      } else if (showLabelledAmount) {
        return 90
      } else if (showLabelledPercentage) {
        return 80
      }
      return 50
    },
    getStatisticsQualityColumnPaddingRight: function () {
      let showLabelledAmount = this.statisticsColumnList.filter(sc => sc.type === 'LABELLED_AMOUNT').length ? 100 : 0
      let showLabelledPercentage = this.statisticsColumnList.filter(sc => sc.type === 'LABELLED_PERCENTAGE').length ? 60 : 0
      if (showLabelledAmount && showLabelledPercentage) {
        return 35
      } else if (showLabelledAmount) {
        return 30
      } else if (showLabelledPercentage) {
        return 25
      }
      return 25
    },
    showStatisticsField: function () {
      return !this.showStatisticsCompare
    },
    getFilterFields: function () {
      let fields = []
      if (this.updateCounter && this.filterFields && this.filterFields.length) {
        for (let filterField of this.filterFields) {
          if (this.filterSupplierList.length === 0 || this.filterSupplierList.filter(fs => fs.id === filterField.supplierId).length) {
            fields.push(filterField)
          }
        }
      }
      return fields
    },
    getOtherFilterFields: function () {
      let fields = []
      if (this.updateCounter && this.filterFields && this.filterFields.length) {
        for (let filterField of this.filterFields) {
          if (this.otherFilterSupplierList.length === 0 || this.otherFilterSupplierList.filter(fs => fs.id === filterField.supplierId).length) {
            fields.push(filterField)
          }
        }
      }
      return fields
    },
    isAnyStatisticExpanded () {
      for (let treeAge in this.expandedStatistics) {
        if (this.expandedStatistics[treeAge] !== undefined && this.expandedStatistics[treeAge] === true) {
          return true
        }
      }
      return false
    },
    showContract: function () {
      return this.currentContract
    },
    canDeleteContract: function () {
      return this.currentContract && this.currentContract.id > 0
    },
    canPrintContract: function () {
      return this.currentContract && this.currentContract.id
    },
    canSendContract: function () {
      return this.currentContract && this.currentContract.id
    },
    showContractButtons: function () {
      return this.currentSupplier && !this.showStatistics && !this.showProduction && !this.showDeliveryReport && !this.currentField
    },
    canCreateContract: function () {
      return this.showContractButtons && !this.contract && /* this.hasItems && */ this.contractLoaded
    },
    hasContract: function () {
      return this.showContractButtons && this.contractLoaded && this.contract != null
    },
    canSaveContract: function () {
      if (this.currentContract) {
        let valuesOk = this.currentContract.contractText && this.currentContract.contractText.trim() !== '' && this.currentContract.buyerSignaturePlace && this.currentContract.buyerSignaturePlace.trim() !== '' && this.currentContract.buyerSignatureDate && this.currentContract.buyerSignatureDate.trim() !== ''
        return valuesOk && (!this.currentContract.id || this.contractDirty)
      }
      return false
    },
    sendEmailCorrect: function () {
      return this.sendEmail && this.sendEmail.trim() !== ''
    },
    ...mapGetters({
      sessionSalesOrganizations: 'session/getSalesOrganizations'
    })
  },
  methods: {
    loadSuppliers () {
      axios.get('/backend/rest/supplier/all?includeSize=true')
        .then(response => {
          this.suppliers = response.data
        })
    },
    loadFilterSuppliers () {
      axios.get('/backend/rest/supplier')
        .then(response => {
          this.filterSuppliers = response.data
        })
    },
    loadFilterFields () {
      axios.get('/backend/rest/field')
        .then(response => {
          this.filterFields = response.data
          this.filterFields.sort(function (f1, f2) {
            return f1.address.nameAndText.localeCompare(f2.address.nameAndText)
          })
        })
    },
    loadFilterProductions () {
      axios.get('/backend/rest/production/all')
        .then(response => {
          this.filterProductions = response.data
        })
    },
    loadContractors () {
      axios.get('/backend/rest/contractor/all')
        .then(response => {
          this.contractors = response.data
          this.contractors.splice(0, 0, {
            id: 0,
            name: ''
          })
        })
    },
    loadCategories () {
      axios.get('/backend/rest/category')
        .then(response => {
          this.categories = response.data
          this.categories.splice(0, 0, {
            id: 0,
            label: ''
          })
        })
    },
    loadContract (displayContract = false) {
      this.contractLoaded = false
      this.contract = null
      if (this.currentSupplier && this.currentSupplier.id) {
        axios.get('/backend/rest/supplier_contract/supplier/' + this.currentSupplier.id)
          .then(response => {
            this.contract = response.data
            if (displayContract) {
              this.displayContract(this.contract)
            }
          })
          .finally(() => {
            this.contractLoaded = true
          })
      }
    },
    supplierFilterChanged () {
      if (this.showStatistics) {
        this.loadStatistics()
      } else {
        this.loadSuppliers()
      }
      this.updateCounter++
    },
    fieldFilterChanged () {
      if (this.showStatistics) {
        this.loadStatistics()
      }
    },
    productionFilterChanged () {
      if (this.showStatistics) {
        this.loadStatistics()
      }
    },
    statisticsColumnChanged () {
      localStorage.setItem('StatisticsColumns', JSON.stringify(this.statisticsColumnList.map(sc => sc.type)))
    },
    otherSupplierFilterChanged () {
      if (this.showStatistics) {
        this.loadOtherStatistics()
      }
      this.updateCounter++
    },
    otherFieldFilterChanged () {
      if (this.showStatistics) {
        this.loadOtherStatistics()
      }
    },
    otherProductionFilterChanged () {
      if (this.showStatistics) {
        this.loadOtherStatistics()
      }
    },
    selectSupplier (item) {
      this.supplierInformation = false
      this.filterFieldInactive = false
      this.fields = []
      this.pickupAddresses = []
      this.currentPickupAddressId = 0
      this.editPrices = false
      for (let c of this.suppliers) {
        if (c.id === item.id) {
          this.currentSupplier = c
          if (this.currentSupplier.address.latitude === 0) {
            this.currentSupplier.address.latitude = ''
          }
          if (this.currentSupplier.address.longitude === 0) {
            this.currentSupplier.address.longitude = ''
          }
          break
        }
      }
      this.loadFields()
      this.loadPrices()
      this.loadSalesOrganizations()
      this.loadPickupAddresses()
      this.loadSupplierFieldSummary()
      this.loadDefaultScraps()
      this.initShowForecast()
      this.initShowProduction()
      this.loadContract()
    },
    async editNewSupplier () {
      await this.loadDefaultScraps()
      this.loadSalesOrganizations()
      this.loadPickupAddresses()
      this.supplierInformation = true
      this.fields = []
      this.pickupAddresses = []
      this.currentSupplier = {
        id: 0,
        name: '',
        number: '',
        vat: '',
        email: '',
        phone: '',
        mobile: '',
        referenceSuppliers: [],
        contractors: [],
        pickupAddress: null,
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
      this.$nextTick(() => this.$refs.name.focus())
    },
    async saveSupplier () {
      await axios.post('/backend/rest/supplier', this.currentSupplier)
        .then(response => {
          // console.log('Got response: ' + response)
          let supplier = response.data
          if (supplier) {
            this.currentSupplier = supplier
          }
          this.supplierInformation = false
          try {
            this.loadSuppliers()
            this.loadSupplierFieldSummary()
          } catch (e) {
          }
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      if (this.currentSupplier && this.currentSupplier.id && this.defaultScraps && this.defaultScraps.length) {
        // Save default scrap values
        await axios.post('/backend/rest/planting/scrap/default/' + this.currentSupplier.id, this.defaultScraps)
      }
    },
    deleteSupplier () {
      axios.delete('/backend/rest/supplier/' + this.currentSupplier.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadSuppliers()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentSupplier = null
    },
    loadFields () {
      axios.get('/backend/rest/field/supplier/' + this.currentSupplier.id + '?includeInactive=true')
        .then(response => {
          this.fields = response.data
        })
    },
    async selectField (item) {
      this.fieldInformation = false
      this.currentPlanting = null
      this.pickupAddresses = []
      this.currentPickupAddressId = 0
      for (let c of this.fields) {
        if (c.id === item.id) {
          this.currentField = c
          if (this.currentField.address.latitude === 0) {
            this.currentField.address.latitude = ''
          }
          if (this.currentField.address.longitude === 0) {
            this.currentField.address.longitude = ''
          }
          if (this.currentField.pickupAddress) {
            this.currentPickupAddressId = this.currentField.pickupAddress
            if (this.currentField.pickupAddress.latitude === 0) {
              this.currentField.pickupAddress.latitude = ''
            }
            if (this.currentField.pickupAddress.longitude === 0) {
              this.currentField.pickupAddress.longitude = ''
            }
          }
          break
        }
      }
      this.initShowForecast()
      this.loadPickupAddresses()
      this.loadPlantings()
      this.loadFieldSummary()
    },
    addField () {
      this.fieldInformation = true
      this.pickupAddresses = []
      this.currentPickupAddressId = 0
      this.currentField = {
        id: 0,
        supplierId: this.currentSupplier.id,
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        },
        pickupAddress: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        },
        inactive: false,
        notStatistic: false
      }
      this.loadPickupAddresses()
      this.clearPlantings()
      this.$nextTick(() => this.$refs.fieldName.focus())
    },
    saveField () {
      axios.post('/backend/rest/field', this.currentField)
        .then(response => {
          this.loadSuppliers()
          this.loadFields()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.fieldInformation = false
    },
    deleteField () {
      axios.delete('/backend/rest/field/' + this.currentField.id)
        .then(response => {
          this.loadFields()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.confirmDeleteFieldDialog = false
      this.currentField = null
    },
    loadPrices () {
      this.prices = []
      axios.get('/backend/rest/supplier/' + this.currentSupplier.id + '/price')
        .then(response => {
          this.prices = response.data
        })
    },
    addPrice () {
      this.prices.push({
        id: 0,
        supplier: {
          id: this.currentSupplier.id
        },
        category: null
      })
      this.editPrices = true
    },
    removePrice (index) {
      this.prices.splice(index, 1)
    },
    startEditPrices () {
      this.editPrices = true
      if (this.prices.length === 0) {
        this.addPrice()
      }
    },
    async cancelPrices () {
      await this.loadPrices()
      this.editPrices = false
    },
    async savePrices () {
      let currentPrices = []
      await axios.get('/backend/rest/supplier/' + this.currentSupplier.id + '/price')
        .then(response => {
          currentPrices = response.data
        })

      // Delete prices that has been removed
      for (let currentPrice of currentPrices) {
        if (this.prices.filter(sp => sp.id === currentPrice.id).length === 0) {
          await axios.delete('/backend/rest/supplier/price/' + currentPrice.id)
        }
      }

      // Save the prices
      for (let price of this.prices) {
        await axios.post('/backend/rest/supplier/price', price)
      }

      await this.loadPrices()
      await this.loadSupplierFieldSummary()
      this.editPrices = false
    },
    async loadPlantingAmountRemaining () {
      this.labelledProductions = []
      this.plantingAmountRemaining = []
      await axios.get('/backend/rest/label_report/field/' + this.currentField.id + '/productions')
        .then(response => {
          this.labelledProductions = response.data
        })
      await axios.get('/backend/rest/planting/field/' + this.currentField.id + '/remaining')
        .then(response => {
          this.plantingAmountRemaining = response.data
        })
    },
    loadPlantings () {
      axios.get('/backend/rest/planting/field/' + this.currentField.id)
        .then(response => {
          this.plantings = response.data
        })
    },
    clearPlantings () {
      this.plantings = []
    },
    async selectPlanting (item) {
      this.currentPlanting = item
      if (this.currentPlanting.season === 'SPRING' && this.currentPlanting.year !== '') {
        this.currentPlanting.year = '' + (Number(this.currentPlanting.year) + 1)
      }
      await this.loadPlantingAmountRemaining()
      this.updateScraps()
      this.updatePlantingAmountRemainings()
    },
    addPlanting () {
      this.currentPlanting = {
        id: 0,
        field: {
          id: this.currentField.id
        },
        size: '',
        year: '',
        season: 'FALL',
        age: '',
        operationalAge: '',
        amount: '',
        provenance: '',
        supplier: '',
        comment: ''
      }
      this.updateScraps()
      this.updatePlantingAmountRemainings()
    },
    async savePlanting () {
      this.currentPlanting.scraps = this.scraps
      this.currentPlanting.remainings = this.remainings
      await axios.post('/backend/rest/planting', this.currentPlanting)
        .then(response => {
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentPlanting = null
      await this.loadPlantings()
      await this.loadFieldSummary()
      this.loadSupplierFieldSummary()
    },
    async deletePlanting () {
      await axios.delete('/backend/rest/planting/' + this.currentPlanting.id)
        .then(response => {
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      await this.loadPlantings()
      this.loadSupplierFieldSummary()
      this.confirmDeletePlantingDialog = false
      this.currentPlanting = null
    },
    loadSalesOrganizations () {
      axios.get('/backend/rest/sales_organization')
        .then(response => {
          this.salesOrganizations = response.data
        })
    },
    loadPickupAddresses () {
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          this.pickupAddresses = response.data
          this.pickupAddresses.splice(0, 0, {
            id: 0,
            street: '',
            houseNo: '',
            location: '',
            zipCode: '',
            city: '',
            country: '',
            latitude: '',
            longitude: '',
            text: ''
          })
          this.pickupAddresses.sort(function (pa1, pa2) {
            return pa1.text.localeCompare(pa2.text)
          })
        })
    },
    async openSupplierInformation () {
      await this.loadDefaultScraps()
      this.supplierInformation = true
    },
    cancelSupplierInformation () {
      this.supplierInformation = false
      this.loadSupplierFieldSummary()
    },
    cancelSupplier () {
      // console.log('Cancel the supplier')
      this.currentSupplier = null
      this.supplierInformation = false
      this.currentField = null
      this.currentPickupAddress = null
      this.loadSuppliers()
    },
    cancelField () {
      this.currentField = null
      this.loadFields()
    },
    cancelPlanting () {
      this.currentPlanting = null
      this.loadPlantings()
    },
    selectPickupAddress () {
      for (let pa of this.pickupAddresses) {
        if (pa.id === this.currentPickupAddressId) {
          this.currentField.pickupAddress = pa
          if (this.currentField.pickupAddress) {
            if (this.currentField.pickupAddress.latitude === 0) {
              this.currentField.pickupAddress.latitude = ''
            }
            if (this.currentField.pickupAddress.longitude === 0) {
              this.currentField.pickupAddress.longitude = ''
            }
          }
          break
        }
      }
    },
    async startShowStatistics () {
      this.filterFieldList = []
      this.filterProductionList = []
      this.otherFilterSupplierList = []
      this.otherFilterFieldList = []
      this.otherFilterProductionList = []

      await this.loadStatistics()
      this.loadStatisticsColumns()
      this.showStatistics = true
      this.showStatisticsCompare = false
    },
    async startShowStatisticsCompare () {
      this.otherFilterSupplierList = []
      this.otherFilterFieldList = []
      this.otherFilterProductionList = []

      await this.loadOtherStatistics()
      this.showStatisticsCompare = true
    },
    endShowStatisticsCompare () {
      this.otherStatistics = null
      this.showStatisticsCompare = false
    },
    loadStatisticsColumns () {
      let sLocalColumns = localStorage.getItem('StatisticsColumns')
      let localColumns = []
      if (sLocalColumns && sLocalColumns !== '') {
        localColumns = JSON.parse(sLocalColumns)
      }
      this.statisticsColumns = []
      this.statisticsColumns.push({
        type: 'SIZE',
        label: 'Size'
      })
      this.statisticsColumns.push({
        type: 'PLANTED_AMOUNT',
        label: 'Planted amount'
      })
      this.statisticsColumns.push({
        type: 'HARVEST_YEAR',
        label: 'Harvest year'
      })
      this.statisticsColumns.push({
        type: 'HARVEST_PERCENTAGE',
        label: 'Harvest %'
      })
      this.statisticsColumns.push({
        type: 'AMOUNT',
        label: 'Amount'
      })
      this.statisticsColumns.push({
        type: 'AMOUNT_PER_HA',
        label: 'Amount / ha'
      })
      this.statisticsColumns.push({
        type: 'LABELLED_AMOUNT',
        label: 'Harvest amount / quality'
      })
      this.statisticsColumns.push({
        type: 'LABELLED_PERCENTAGE',
        label: 'Harvest % / quality'
      })
      if (this.statisticQualities && this.statisticQualities.length) {
        for (let quality of this.statisticQualities) {
          this.statisticsColumns.push({
            type: 'QUALITY_' + quality,
            label: quality
          })
        }
      }

      this.statisticsColumnList = []
      for (let statisticsColumn of this.statisticsColumns) {
        if (localColumns.length === 0 || localColumns.includes(statisticsColumn.type)) {
          this.statisticsColumnList.push(statisticsColumn)
        }
      }
    },
    async loadStatistics () {
      this.statistics = await this.loadStatisticsData(this.filterSupplierList, this.filterFieldList, this.filterProductionList)
    },
    async loadOtherStatistics () {
      this.otherStatistics = await this.loadStatisticsData(this.otherFilterSupplierList, this.otherFilterFieldList, this.otherFilterProductionList)
    },
    async loadStatisticsData (supplierList, fieldList, productionList) {
      let result = []
      let years = productionList && productionList.length ? productionList.map((s) => s.name).join(',') : ''
      let suppliers = supplierList && supplierList.length ? supplierList.map((s) => s.id).join(',') : ''
      let fields = fieldList && fieldList.length ? fieldList.map((s) => s.id).join(',') : ''
      let params = '?years=' + years + '&suppliers=' + suppliers + '&fields=' + fields

      await axios.get('/backend/rest/supplier/statistics' + params)
        .then(response => {
          let statistics = response.data
          result = []
          let lastTreeAge = 0
          let labelledByQuality = {}
          let utilizedByQuality = {}
          let size = 0
          let amount = 0
          let totalLabelled = 0
          let totalLabelledByTreeAge = 0
          let totalLabelledByQuality = {}
          let totalUtilizedByQuality = {}
          if (statistics && statistics.length) {
            let tempStatistics = []
            for (let stat of statistics) {
              let treeAge = stat.treeAge
              if (lastTreeAge && treeAge !== lastTreeAge) {
                // Change in tree age
                for (let quality in labelledByQuality) {
                  utilizedByQuality[quality] = labelledByQuality[quality] && totalLabelledByTreeAge ? labelledByQuality[quality] * 100 / totalLabelledByTreeAge : 0
                }

                result.push({
                  type: 'SUMMARY',
                  treeAge: lastTreeAge,
                  planting: {
                    id: 0,
                    size: size,
                    amount: amount
                  },
                  harvestPercentage: totalLabelledByTreeAge * 100 / amount,
                  amount: totalLabelledByTreeAge,
                  amountPerHa: Math.round(totalLabelledByTreeAge / size),
                  labelledByQuality: labelledByQuality,
                  utilizedByQuality: utilizedByQuality
                })
                for (let stat of tempStatistics) {
                  stat.type = 'FIELD'
                  stat.harvestPercentage = this.getLabelledTotal(stat) * 100 / stat.planting.amount
                  stat.amount = this.getLabelledTotal(stat)
                  stat.amountPerHa = Math.round(this.getLabelledTotal(stat) / stat.planting.size)
                  result.push(stat)
                }
                tempStatistics = []
                labelledByQuality = {}
                utilizedByQuality = {}
                size = 0
                amount = 0
                totalLabelledByTreeAge = 0
              }

              tempStatistics.push(stat)
              size += stat.planting.size
              amount += stat.planting.amount
              if (stat.labelledByQuality) {
                for (let quality in stat.labelledByQuality) {
                  let labelled = stat.labelledByQuality[quality]
                  if (!labelledByQuality[quality]) {
                    labelledByQuality[quality] = 0
                  }
                  labelledByQuality[quality] = labelledByQuality[quality] + labelled
                  if (!totalLabelledByQuality[quality]) {
                    totalLabelledByQuality[quality] = 0
                  }
                  totalLabelledByQuality[quality] = totalLabelledByQuality[quality] + labelled
                  totalLabelledByTreeAge += labelled
                  totalLabelled += labelled
                }
              }
              lastTreeAge = treeAge
            }

            for (let quality in labelledByQuality) {
              utilizedByQuality[quality] = labelledByQuality[quality] && totalLabelledByTreeAge ? labelledByQuality[quality] * 100 / totalLabelledByTreeAge : 0
            }
            result.push({
              type: 'SUMMARY',
              treeAge: lastTreeAge,
              planting: {
                id: 0,
                size: size,
                amount: amount
              },
              harvestPercentage: totalLabelledByTreeAge * 100 / amount,
              amount: totalLabelledByTreeAge,
              amountPerHa: Math.round(totalLabelledByTreeAge / size),
              labelledByQuality: labelledByQuality,
              utilizedByQuality: utilizedByQuality
            })
            for (let stat of tempStatistics) {
              stat.type = 'FIELD'
              stat.harvestPercentage = this.getLabelledTotal(stat) * 100 / stat.planting.amount
              stat.amount = this.getLabelledTotal(stat)
              stat.amountPerHa = Math.round(this.getLabelledTotal(stat) / stat.planting.size)
              result.push(stat)
            }

            for (let quality in totalLabelledByQuality) {
              totalUtilizedByQuality[quality] = totalLabelledByQuality[quality] * 100 / totalLabelled
            }
            result.push({
              type: 'TOTAL',
              treeAge: '',
              planting: {
                id: 0,
                size: 0,
                amount: 0
              },
              harvestPercentage: 0,
              amount: totalLabelled,
              amountPerHa: 0,
              labelledByQuality: totalLabelledByQuality,
              utilizedByQuality: totalUtilizedByQuality
            })
          }
        })
      return result
    },
    getLabelledTotal (statistic) {
      let total = 0
      if (statistic.labelledByQuality) {
        for (let quality in statistic.labelledByQuality) {
          total += statistic.labelledByQuality[quality]
        }
      }
      return total
    },
    endShowStatistics () {
      this.showStatistics = false
    },
    startShowProduction () {
      this.loadPallets()
      this.showProduction = true
    },
    printProduction () {
      let url = '/backend/print/supplierProduction.xhtml?supplierId=' + this.currentSupplier.id + '&title=Production'
      window.open(url)
    },
    excelProduction () {
      let url = '/backend/report/productionReport/supplier?supplierId=' + this.currentSupplier.id + '&uuid=' + uuid()
      window.open(url)
    },
    endShowProduction () {
      this.showProduction = false
    },
    getPalletCategories (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + (item.amount ? item.amount : 0) + 'pcs.'
        }
      }
      return categories
    },
    loadPallets () {
      axios.get('/backend/rest/pallet/supplier/' + this.currentSupplier.id)
        .then(response => {
          this.pallets = response.data
          if (this.pallets) {
            for (let p of this.pallets) {
              p.categoriesText = this.getPalletCategories(p)
            }
          }
        })
    },
    startShowDeliveryReport () {
      this.loadDeliveryReport()
      this.showDeliveryReport = true
    },
    printDeliveryReport () {
      let url = '/backend/print/deliveryReport.xhtml?supplierId=' + this.currentSupplier.id + '&title=Delivery report'
      window.open(url)
    },
    excelDeliveryReport () {
      let url = '/backend/report/deliveryReport?supplierId=' + this.currentSupplier.id
      window.open(url)
    },
    endShowDeliveryReport () {
      this.showDeliveryReport = false
    },
    loadDeliveryReport () {
      this.deliveryReport = null
      axios.get('/backend/rest/delivery_report/supplier/' + this.currentSupplier.id)
        .then(response => {
          this.deliveryReport = response.data
          if (this.deliveryReport && this.deliveryReport.items) {
            let total = 0
            for (let item of this.deliveryReport.items) {
              total += item.amount
            }
            this.deliveryReport.items.push({
              category: null,
              amount: total
            })
          }
        })
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    },
    toggleFilterFieldInactive (inactive) {
      this.filterFieldInactive = inactive
    },
    getContractorNames (supplier) {
      let names = ''
      if (supplier && supplier.contractors && supplier.contractors.length) {
        for (let contractor of supplier.contractors) {
          if (names !== '') {
            names += ', '
          }
          names += contractor.name
        }
      }
      return names
    },
    getReferenceSupplierNames (supplier) {
      let names = ''
      if (supplier && supplier.referenceSuppliers && supplier.referenceSuppliers.length) {
        for (let refSupplier of supplier.referenceSuppliers) {
          if (names !== '') {
            names += ', '
          }
          names += refSupplier.name
        }
      }
      return names
    },
    keypressNumberFieldWithDecimals: function (event) {
      let decimalSeparator = '.'
      if (event.charCode === 0 || /\d/.test(String.fromCharCode(event.charCode)) || (decimalSeparator.includes(String.fromCharCode(event.charCode)) && (!this.content || !this.content.includes(decimalSeparator)))) {
        return true
      } else {
        event.preventDefault()
      }
    },
    keypressNumberField: function (event) {
      if (event.charCode === 0 || /\d/.test(String.fromCharCode(event.charCode))) {
        return true
      } else {
        event.preventDefault()
      }
    },
    async loadDefaultScraps () {
      let defaultScraps = []

      if (this.currentSupplier && this.currentSupplier.id) {
        await axios.get('/backend/rest/planting/scrap/default/' + this.currentSupplier.id)
          .then(response => {
            defaultScraps = response.data
          })
      }

      if (!(defaultScraps && defaultScraps.length)) {
        defaultScraps = []
        for (let i = 4; i <= 14; i++) {
          defaultScraps.push({
            id: 0,
            age: i,
            value: 0
          })
        }
      }
      this.defaultScraps = defaultScraps
    },
    removeDefaultScrap (index) {
      if (this.defaultScraps && index < this.defaultScraps.length) {
        this.defaultScraps.splice(index, 1)
      }
    },
    addDefaultScrap () {
      if (!this.defaultScraps) {
        this.defaultScraps = []
      }
      this.defaultScraps.push({
        id: 0,
        age: 1,
        value: 0
      })
    },
    async loadSupplierFieldChartSummaries () {
      this.suppliersFieldChartMinPlantAge = -1
      this.suppliersFieldChartMaxPlantAge = -1

      await axios.get('/backend/rest/supplier/summary/chart')
        .then(response => {
          let suppliersFieldChartSummary = response.data
          if (suppliersFieldChartSummary) {
            // Find min and max plant age
            for (let supplierFieldChartSummary of suppliersFieldChartSummary) {
              if (supplierFieldChartSummary.fieldSummaries && supplierFieldChartSummary.fieldSummaries.length) {
                for (let fieldSummary of supplierFieldChartSummary.fieldSummaries) {
                  if (this.suppliersFieldChartMinPlantAge === -1 || fieldSummary.plantAge < this.suppliersFieldChartMinPlantAge) {
                    this.suppliersFieldChartMinPlantAge = fieldSummary.plantAge
                  }
                  if (this.suppliersFieldChartMaxPlantAge === -1 || fieldSummary.plantAge > this.suppliersFieldChartMaxPlantAge) {
                    this.suppliersFieldChartMaxPlantAge = fieldSummary.plantAge
                  }
                }
              }
            }
          }
          this.suppliersFieldChartSummary = suppliersFieldChartSummary
        })
    },
    async loadSupplierFieldSummary () {
      this.supplierFieldSummaryReady = false
      this.supplierFieldSummaryData = []
      this.supplierForecastDatas = []
      this.supplierProductionForecastFoundations = []
      await axios.get('/backend/rest/supplier/summary/' + this.currentSupplier.id)
        .then(response => {
          let supplierFieldSummary = response.data
          if (supplierFieldSummary && supplierFieldSummary.fieldSummaries && supplierFieldSummary.fieldSummaries.length) {
            let fieldSummaries = supplierFieldSummary.fieldSummaries
            fieldSummaries.sort(function (s1, s2) {
              let res = s2.plantAge - s1.plantAge
              if (res === 0) {
                res = s1.field.id - s2.field.id
              }
              return res
            })

            for (let fieldSummary of fieldSummaries) {
              let forecast = 0
              if (fieldSummary.forecasts && fieldSummary.forecasts.length && fieldSummary.forecasts[0].year === Number(this.activeProductionName)) {
                forecast = fieldSummary.forecasts[0].adjustedAmount
              }
              this.supplierFieldSummaryData.push({
                type: 'field',
                field: fieldSummary.field,
                planting: fieldSummary.planting,
                plantAge: fieldSummary.plantAge,
                fieldAge: fieldSummary.fieldAge,
                amountPerHa: fieldSummary.planting ? Math.round(fieldSummary.planting.amount / fieldSummary.planting.size) : null,
                amountRemaining: fieldSummary.amountRemaining,
                amountRemainingPerHa: fieldSummary.planting ? Math.round(fieldSummary.amountRemaining / fieldSummary.planting.size) : null,
                forecast: forecast,
                forecastPerHa: fieldSummary.planting ? Math.round(forecast / fieldSummary.planting.size) : null
              })
            }
          }

          if (supplierFieldSummary && supplierFieldSummary.supplierForecasts && supplierFieldSummary.supplierForecasts.length) {
            for (let supplierForecast of supplierFieldSummary.supplierForecasts) {
              if (supplierForecast.families) {
                let supplierForecastData = []
                let totalAmount = 0
                for (let family of supplierForecast.families) {
                  let amount = Math.round(supplierForecast.amounts[family.id])
                  supplierForecastData.push({
                    year: supplierForecast.year,
                    type: 'LINE',
                    family: family,
                    amount: amount
                  })

                  totalAmount += amount

                  // Fill in the expanded lines
                  for (let forecastFoundation of supplierForecast.forecastFoundations) {
                    let expandedAmount = forecastFoundation.amounts[family.id]
                    if (expandedAmount > 0) {
                      supplierForecastData.push({
                        year: supplierForecast.year,
                        type: 'LINE_EXPANDED',
                        family: family,
                        field: forecastFoundation.field,
                        forecastFoundation: forecastFoundation,
                        amount: Math.round(expandedAmount),
                        amountPerHa: Math.round(expandedAmount / forecastFoundation.planting.size)
                      })
                    }
                  }
                }
                supplierForecastData.push({
                  year: supplierForecast.year,
                  type: 'TOTAL',
                  family: '',
                  amount: totalAmount
                })

                this.supplierForecastDatas.push(supplierForecastData)
              }
            }
          }
          // console.log('Supplier field summary: ' + JSON.stringify(supplierFieldSummary, null, 2))

          if (supplierFieldSummary && supplierFieldSummary.forecastFoundations && supplierFieldSummary.forecastFoundations.length) {
            let foundations = supplierFieldSummary.forecastFoundations
            let lastAge = 0
            let lastYear = 0
            for (let foundation of foundations) {
              if (foundation.categories && foundation.categories.length) {
                let subTotalAmount = 0
                for (let category of foundation.categories) {
                  this.supplierProductionForecastFoundations.push({
                    type: 'LINE',
                    age: foundation.age !== lastAge ? foundation.age : '',
                    // year: foundation.productionYear !== lastYear ? foundation.productionYear : '',
                    year: foundation.productionYear,
                    displayYear: foundation.productionYear !== lastYear,
                    category: category.displayLabel,
                    amount: foundation.categoryAmounts[category.id],
                    unitPrice: foundation.unitPrices[category.id],
                    price: foundation.prices[category.id]
                  })
                  lastAge = foundation.age
                  lastYear = foundation.productionYear
                  subTotalAmount += foundation.categoryAmounts[category.id]
                }

                this.supplierProductionForecastFoundations.push({
                  type: 'SUB_TOTAL',
                  age: '',
                  year: foundation.productionYear,
                  displayYear: false,
                  family: '',
                  amount: subTotalAmount,
                  unitPrice: '',
                  price: foundation.totalPrice
                })
              }
            }
          }

          this.supplierFieldSummaryReady = true
        })
        .catch((error) => {
          console.log('Failed to get supplier field summary: ' + error)
        })
    },
    async loadFieldSummary (reload = false) {
      if (!reload) {
        this.fieldSummaryReady = false
        this.fieldSummary = null
        this.fieldProductionForecastFoundations = []
        this.fieldProductionCategoryForecastFoundations = []
        this.fieldForecastDatas = []
      }

      await axios.get('/backend/rest/field/summary/' + this.currentField.id)
        .then(response => {
          this.fieldSummary = response.data
          this.fieldPlanting = this.fieldSummary.planting
          let fieldSize = this.fieldPlanting ? this.fieldPlanting.size : 0

          let forecasts = this.fieldSummary.forecasts
          if (forecasts && forecasts.length) {
            this.fieldForecastDatas = []

            for (let forecast of forecasts) {
              let year = forecast.year
              let remainingAmounts = this.fieldPlanting && this.fieldPlanting.remainings ? this.fieldPlanting.remainings.filter(r => Number(r.production.name) === year) : null
              let remainingAmount = remainingAmounts && remainingAmounts.length ? remainingAmounts[0].amount : 0

              if (forecast && forecast.families && forecast.families.length) {
                let fieldForecastData = []
                let totalAmount = 0
                let totalPercent = 0
                for (let family of forecast.families) {
                  let overrideFamily = false
                  for (let f of forecast.overrides) {
                    if (f.id === family.id) {
                      overrideFamily = true
                      break
                    }
                  }
                  let removedFamily = false
                  for (let f of forecast.removed) {
                    if (f.id === family.id) {
                      removedFamily = true
                      break
                    }
                  }
                  let foundationCount = 0
                  for (let forecastFoundation of forecast.forecastFoundations) {
                    let expandedAmount = forecastFoundation.amounts[family.id]
                    if (expandedAmount >= 0) {
                      foundationCount++
                    }
                  }

                  let amount = forecast.amounts[family.id]
                  fieldForecastData.push({
                    year: forecast.year,
                    type: 'LINE',
                    family: family,
                    amount: Math.round(amount),
                    amountPerHa: Math.round(fieldSize ? amount / fieldSize : 0),
                    percentage: remainingAmount ? amount * 100 / remainingAmount : 0,
                    distribution: forecast.distributions[family.id],
                    foundationCount: foundationCount,
                    override: overrideFamily,
                    removed: removedFamily
                  })
                  totalAmount += Math.round(amount)
                  totalPercent += (remainingAmount ? amount * 100 / remainingAmount : 0)

                  // Fill in the expanded lines
                  for (let forecastFoundation of forecast.forecastFoundations) {
                    let expandedAmount = forecastFoundation.amounts[family.id]
                    let expandedPercentage = forecastFoundation.percentages[family.id]
                    if (expandedAmount >= 0) {
                      fieldForecastData.push({
                        year: forecast.year,
                        type: 'LINE_EXPANDED',
                        family: family,
                        field: forecastFoundation.field,
                        forecastFoundation: forecastFoundation,
                        amount: Math.round(expandedAmount),
                        amountPerHa: Math.round(expandedAmount / forecastFoundation.planting.size),
                        percentage: expandedPercentage
                      })
                    }
                  }
                }
                fieldForecastData.push({
                  type: 'TOTAL',
                  family: '',
                  amount: totalAmount,
                  amountPerHa: '',
                  percentage: totalPercent,
                  override: forecast.totalOverride
                })

                this.fieldForecastDatas.push(fieldForecastData)
              }
            }
          }
          let foundations = this.fieldSummary.forecastFoundations
          this.fieldProductionForecastFoundations = []
          this.fieldProductionCategoryForecastFoundations = []
          this.chartFieldSummary = null
          if (foundations && foundations.length) {
            let lastAge = 0
            for (let foundation of foundations) {
              if (foundation.families && foundation.families.length) {
                let lastQuality = null
                let totalQualityAmount = 0
                let totalQualityPercent = 0
                for (let family of foundation.families) {
                  if (lastQuality && lastQuality !== family.quality) {
                    this.fieldProductionForecastFoundations.push({
                      type: 'SUB_TOTAL',
                      age: '',
                      year: foundation.productionYear,
                      family: {
                        displayLabel: ''
                      },
                      amount: totalQualityAmount,
                      amountPerHa: fieldSize ? totalQualityAmount / fieldSize : 0,
                      percentage: totalQualityPercent
                    })
                    totalQualityAmount = 0
                    totalQualityPercent = 0
                  }

                  this.fieldProductionForecastFoundations.push({
                    type: 'LINE',
                    age: foundation.age !== lastAge ? foundation.age : '',
                    year: foundation.productionYear,
                    family: family,
                    amount: foundation.amounts[family.id],
                    amountPerHa: fieldSize ? foundation.amounts[family.id] / fieldSize : 0,
                    percentage: foundation.percentages[family.id],
                    forecastFoundation: foundation,
                    field: foundation.field
                  })
                  totalQualityAmount += foundation.amounts[family.id]
                  totalQualityPercent += foundation.percentages[family.id]
                  lastAge = foundation.age
                  lastQuality = family.quality
                }

                if (totalQualityAmount) {
                  this.fieldProductionForecastFoundations.push({
                    type: 'SUB_TOTAL',
                    age: '',
                    year: foundation.productionYear,
                    family: {
                      displayLabel: ''
                    },
                    amount: totalQualityAmount,
                    amountPerHa: fieldSize ? totalQualityAmount / fieldSize : 0,
                    percentage: totalQualityPercent
                  })
                }

                this.fieldProductionForecastFoundations.push({
                  type: 'TOTAL',
                  age: '',
                  year: foundation.productionYear,
                  family: {
                    displayLabel: ''
                  },
                  amount: foundation.totalAmount,
                  amountPerHa: fieldSize ? foundation.totalAmount / fieldSize : 0,
                  percentage: foundation.totalPercent
                })
              }

              lastAge = 0
              if (foundation.categories && foundation.categories.length) {
                let lastQuality = null
                let totalQualityAmount = 0
                let totalQualityPercent = 0
                let totalQualityPrice = 0
                for (let category of foundation.categories) {
                  if (lastQuality && lastQuality !== category.quality) {
                    this.fieldProductionCategoryForecastFoundations.push({
                      type: 'SUB_TOTAL',
                      age: '',
                      year: foundation.productionYear,
                      family: '',
                      amount: totalQualityAmount,
                      amountPerHa: fieldSize ? totalQualityAmount / fieldSize : 0,
                      percentage: totalQualityPercent,
                      unitPrice: totalQualityAmount ? totalQualityPrice / totalQualityAmount : 0,
                      price: totalQualityPrice
                    })
                    totalQualityAmount = 0
                    totalQualityPercent = 0
                    totalQualityPrice = 0
                  }

                  this.fieldProductionCategoryForecastFoundations.push({
                    type: 'LINE',
                    age: foundation.age !== lastAge ? foundation.age : '',
                    year: foundation.productionYear,
                    family: category.displayLabel,
                    amount: foundation.categoryAmounts[category.id],
                    amountPerHa: fieldSize ? foundation.categoryAmounts[category.id] / fieldSize : 0,
                    percentage: foundation.categoryPercentages[category.id],
                    unitPrice: foundation.unitPrices[category.id],
                    price: foundation.prices[category.id]
                  })
                  totalQualityAmount += foundation.categoryAmounts[category.id]
                  totalQualityPercent += foundation.categoryPercentages[category.id]
                  totalQualityPrice += foundation.prices[category.id]
                  lastAge = foundation.age
                  lastQuality = category.quality
                }

                if (totalQualityAmount) {
                  this.fieldProductionCategoryForecastFoundations.push({
                    type: 'SUB_TOTAL',
                    age: '',
                    year: foundation.productionYear,
                    family: '',
                    amount: totalQualityAmount,
                    amountPerHa: fieldSize ? totalQualityAmount / fieldSize : 0,
                    percentage: totalQualityPercent,
                    unitPrice: totalQualityAmount ? totalQualityPrice / totalQualityAmount : 0,
                    price: totalQualityPrice
                  })
                }

                this.fieldProductionCategoryForecastFoundations.push({
                  type: 'TOTAL',
                  age: '',
                  year: foundation.productionYear,
                  family: '',
                  amount: foundation.totalCategoryAmount,
                  amountPerHa: fieldSize ? foundation.totalCategoryAmount / fieldSize : 0,
                  percentage: foundation.totalCategoryPercent,
                  unitPrice: foundation.totalCategoryAmount ? foundation.totalPrice / foundation.totalCategoryAmount : 0,
                  price: foundation.totalPrice
                })
              }
            }
          }

          // Load for the chart
          this.chartFieldSummary = this.fieldSummary.chartFieldSummary
          this.fieldSummaryKey++
          this.fieldSummaryReady = true
        })
        .catch((error) => {
          console.log('Failed to get field summary: ' + error)
        })
    },
    toggleProduction () {
      this.showProductionByCategory = !this.showProductionByCategory
    },
    showForecastData (fieldForecastData) {
      return (fieldForecastData.type !== 'LINE_EXPANDED') || this.expandedFamilies.get(fieldForecastData.year + '_' + fieldForecastData.family.id)
    },
    showForecastYear (year) {
      return this.showForecastYears[year]
    },
    toggleForecastYear (year) {
      this.$set(this.showForecastYears, year, !this.showForecastYears[year])
    },
    initShowForecast () {
      let showForecastYears = {}
      try {
        let year = this.$store.getters['session/getActiveProduction'].from.substring(0, '2000'.length)
        showForecastYears[year] = true
      } catch (e) {
        showForecastYears[new Date().getFullYear()] = true
      }
      this.showForecastYears = showForecastYears
    },
    showProductionYear (year) {
      return this.showProductionYears[year]
    },
    toggleProductionYear (year) {
      this.$set(this.showProductionYears, year, !this.showProductionYears[year])
    },
    initShowProduction () {
      let showProductionYears = {}
      try {
        let year = this.$store.getters['session/getActiveProduction'].from.substring(0, '2000'.length)
        showProductionYears[year] = true
      } catch (e) {
        showProductionYears[new Date().getFullYear()] = true
      }
      this.showProductionYears = showProductionYears
    },
    showExpandIconForSupplier (fieldForecastData) {
      return fieldForecastData.type === 'LINE' && !this.expandedFamilies.get(fieldForecastData.year + '_' + fieldForecastData.family.id)
    },
    showCollapseIconForSupplier (fieldForecastData) {
      return fieldForecastData.type === 'LINE' && this.expandedFamilies.get(fieldForecastData.year + '_' + fieldForecastData.family.id)
    },
    showExpandIcon (fieldForecastData) {
      return fieldForecastData.type === 'LINE' && fieldForecastData.foundationCount && !this.expandedFamilies.get(fieldForecastData.year + '_' + fieldForecastData.family.id)
    },
    showCollapseIcon (fieldForecastData) {
      return fieldForecastData.type === 'LINE' && fieldForecastData.foundationCount && this.expandedFamilies.get(fieldForecastData.year + '_' + fieldForecastData.family.id)
    },
    forecastFamilyClicked (fieldForecastData) {
      let key = fieldForecastData.year + '_' + fieldForecastData.family.id
      let expanded = this.expandedFamilies.get(key)
      expanded = !expanded
      this.expandedFamilies.set(key, expanded)
      this.updateCounter++
    },
    hasPercentageAdjustment (fieldForecastData) {
      let adjustment = this.getAdjustment(fieldForecastData)
      return adjustment != null && ((adjustment.percentage && adjustment.percentage >= 0) || adjustment.disabled)
    },
    hasAmountAdjustment (fieldForecastData) {
      let adjustment = this.getAdjustment(fieldForecastData)
      return adjustment != null && ((adjustment.amount && adjustment.amount >= 0) || adjustment.disabled)
    },
    getAdjustment (fieldForecastData) {
      if (fieldForecastData) {
        return fieldForecastData.forecastFoundation && fieldForecastData.forecastFoundation.adjustments && fieldForecastData.forecastFoundation.adjustments[fieldForecastData.family.id]
      }
      return null
    },
    createOrEditForecastAdjustment (fieldForecastData) {
      this.forecastAdjustment = this.getAdjustment(fieldForecastData)

      if (!this.forecastAdjustment) {
        this.forecastAdjustment = {
          id: 0,
          production: {
            id: fieldForecastData.forecastFoundation.productionId,
            name: fieldForecastData.forecastFoundation.productionYear
          },
          field: fieldForecastData.field,
          family: fieldForecastData.family,
          amount: fieldForecastData.amount,
          percentage: fieldForecastData.percentage.toFixed(2),
          disabled: false
        }
      }

      this.forecastAdjustmentDialog = true
    },
    forecastAdjustmentDisabledChanged () {
      if (this.forecastAdjustment.disabled) {
        this.forecastAdjustment.amount = ''
        this.forecastAdjustment.percentage = ''
      }
    },
    async saveForecastAdjustment () {
      await axios.post('/backend/rest/forecast/adjustment', this.forecastAdjustment)
        .then(response => {
          this.forecastAdjustmentDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      this.loadSupplierFieldSummary()
    },
    async deleteForecastAdjustment () {
      await axios.delete('/backend/rest/forecast/adjustment/' + this.forecastAdjustment.id)
        .then(response => {
          this.forecastAdjustmentDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      this.loadSupplierFieldSummary()
    },
    cancelForecastAdjustment () {
      this.forecastAdjustmentDialog = false
    },
    createOrEditForecastOverride (fieldForecastData) {
      if (Number(this.activeProductionName) === fieldForecastData.year) {
        this.forecastOverrideDeletable = fieldForecastData.override || fieldForecastData.removed
        this.forecastOverride = {
          production: this.$store.getters['session/getActiveProduction'],
          field: this.currentField,
          family: fieldForecastData.family,
          amount: fieldForecastData.amount
        }

        this.forecastOverrideDialog = true
      }
    },
    async saveForecastOverride () {
      this.forecastOverrideDialog = false

      await axios.post('/backend/rest/forecast/override', this.forecastOverride)
        .then(response => {
          this.forecastOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      this.loadSupplierFieldSummary()
    },
    async deleteForecastOverride () {
      this.forecastOverrideDialog = false

      await axios.delete('/backend/rest/forecast/override/' + this.forecastOverride.production.id + '/' + this.forecastOverride.field.id + '/' + this.forecastOverride.family.id)
        .then(response => {
          this.forecastOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      this.loadSupplierFieldSummary()
    },
    cancelForecastOverride () {
      this.forecastOverrideDialog = false
    },
    createOrEditForecastTotalOverride (fieldForecastData) {
      this.forecastTotalOverrideDeletable = fieldForecastData.override
      this.forecastTotalOverride = {
        production: this.$store.getters['session/getActiveProduction'],
        field: this.currentField,
        family: null,
        amount: fieldForecastData.amount
      }
      this.forecastTotalOverrideDialog = true
    },
    async saveForecastTotalOverride () {
      this.forecastTotalOverrideDialog = false

      await axios.post('/backend/rest/forecast/override', this.forecastTotalOverride)
        .then(response => {
          this.forecastTotalOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      this.loadSupplierFieldSummary()
    },
    async deleteForecastTotalOverride () {
      this.forecastTotalOverrideDialog = false

      await axios.delete('/backend/rest/forecast/override/' + this.forecastTotalOverride.production.id + '/' + this.forecastTotalOverride.field.id + '/0')
        .then(response => {
          this.forecastTotalOverrideDialog = false
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      this.loadSupplierFieldSummary()
    },
    cancelForecastTotalOverride () {
      this.forecastTotalOverrideDialog = false
    },
    canRemoveFamily (fieldForecastData) {
      return Number(this.activeProductionName) === fieldForecastData.year && !fieldForecastData.override && !fieldForecastData.removed
    },
    canRestoreFamily (fieldForecastData) {
      return Number(this.activeProductionName) === fieldForecastData.year && fieldForecastData.removed
    },
    async removeFamily (fieldForecastData) {
      let forecastOverride = {
        production: this.$store.getters['session/getActiveProduction'],
        field: this.currentField,
        family: fieldForecastData.family,
        amount: 0,
        removed: true
      }

      await axios.post('/backend/rest/forecast/override', forecastOverride)
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      await this.loadSupplierFieldSummary()
    },
    async restoreFamily (fieldForecastData) {
      let production = this.$store.getters['session/getActiveProduction']
      let field = this.currentField
      await axios.delete('/backend/rest/forecast/override/' + production.id + '/' + field.id + '/' + fieldForecastData.family.id)
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })

      await this.loadFieldSummary(true)
      await this.loadSupplierFieldSummary()
    },
    formatNumber (number, digits) {
      return NumberUtil.format(number, digits)
    },
    operationalAgeChanged () {
      this.updateScraps()
    },
    plantingYearChanged () {
      this.updatePlantingAmountRemainings()
    },
    seasonChanged (season) {
      this.currentPlanting.season = season
      this.plantingYearChanged()
    },
    updateScraps () {
      this.scraps = []
      if (this.currentPlanting) {
        for (let age = 4; age <= this.currentPlanting.operationalAge; age++) {
          let scrapValue = 0
          if (this.defaultScraps && this.defaultScraps.length) {
            let defaultScraps = this.defaultScraps.filter(ds => ds.age === age)
            if (defaultScraps && defaultScraps.length) {
              scrapValue = defaultScraps[0].value
            }
          }
          let scrap = {
            id: 0,
            age: age,
            value: scrapValue
          }
          if (this.currentPlanting.scraps && this.currentPlanting.scraps.length) {
            for (let s of this.currentPlanting.scraps) {
              if (s.age === age) {
                scrap.id = s.id
                scrap.value = s.value
                break
              }
            }
          }
          this.scraps.push(scrap)
        }
      }
    },
    updatePlantingAmountRemainings () {
      this.remainings = []
      if (this.currentPlanting && this.currentPlanting.year) {
        let currentProduction = this.$store.getters['session/getActiveProduction']
        let productions = []
        if (this.labelledProductions.length > 0) {
          for (let production of this.labelledProductions) {
            productions.push(production)
          }
        }
        if (productions.length === 0 || productions[productions.length - 1].id !== currentProduction.id) {
          productions.push(currentProduction)
        }
        for (let production of productions) {
          let productionYear = Number(production.name)
          let plantingYear = Number(this.currentPlanting.year)
          if (this.currentPlanting.season === 'SPRING') {
            plantingYear -= 1
          }
          if (productionYear >= plantingYear + 4) {
            let remaining = {
              id: 0,
              production: production,
              amount: ''
            }
            if (this.currentPlanting.remainings && this.currentPlanting.remainings.length) {
              for (let r of this.currentPlanting.remainings) {
                if (r.production.id === production.id) {
                  remaining.id = r.id
                  remaining.amount = (r.amount ? r.amount : '')
                  break
                }
              }
            }
            this.remainings.push(remaining)
          }
        }
      }
    },
    async autoFillRemainingAmounts () {
      if (this.remainings.length) {
        let planting = JSON.parse(JSON.stringify(this.currentPlanting))
        planting.scraps = this.scraps
        planting.remainings = this.remainings

        await axios.post('/backend/rest/planting/remaining/autofill', planting)
          .then(response => {
            let remainings = response.data.remainings
            for (let remaining of this.remainings) {
              for (let r of remainings) {
                if (remaining.production.id === r.production.id) {
                  remaining.amount = r.amount
                }
              }
            }
          })
      }
    },
    async autoFillRemainingAmountsCurrentYear () {
      if (this.remainings && this.remainings.length) {
        this.remainings[this.remainings.length - 1].amount = ''
        await this.autoFillRemainingAmounts()
        this.scrapChangedCurrentYearDialog = false
      }
    },
    getUtilization (planting) {
      let utilization = 100
      if (planting && planting.scraps && planting.scraps.length) {
        utilization = new ScrapUtil().getUtilization(planting.scraps)
        if (utilization < 0) {
          utilization = 0
        }
      }
      return utilization.toFixed(1)
    },
    getRemainingAmount (planting) {
      if (planting && planting.remainings && planting.remainings.length) {
        return planting.remainings[planting.remainings.length - 1].amount
      }
      return 0
    },
    scrapChanged (scrap) {
      if (this.remainings && this.remainings.length && this.remainings[this.remainings.length - 1].amount !== '' && this.remainings[this.remainings.length - 1].amount !== '0') {
        let currentProduction = this.$store.getters['session/getActiveProduction']
        let productionYear = Number(currentProduction.name)
        let plantingYear = Number(this.currentPlanting.year)
        if (this.currentPlanting.season === 'SPRING') {
          plantingYear -= 1
        }
        let age = scrap.age
        if (plantingYear + age === productionYear) {
          // alert('Scrap changed for current year')
          this.scrapChangedCurrentYearDialog = true
        }
      }
    },
    getForecastFoundations (fieldForecastData) {
      let forecastFoundations = []
      for (let ffd of fieldForecastData) {
        if (ffd.forecastFoundation && forecastFoundations.filter(ff => ff.field.id === ffd.forecastFoundation.field.id).length === 0) {
          forecastFoundations.push(ffd.forecastFoundation)
        }
      }
      forecastFoundations.sort(function (ff1, ff2) {
        return (ff1.field.address.name).localeCompare((ff2.field.address.name))
      })
      return forecastFoundations
    },
    getStatisticAmountByQuality (statistic, quality) {
      if (statistic && statistic.labelledByQuality && quality && statistic.labelledByQuality[quality]) {
        return statistic.labelledByQuality[quality]
      }
      return 0
    },
    getStatisticUtilizedByQuality (statistic, quality) {
      if (statistic && statistic.utilizedByQuality && quality && statistic.utilizedByQuality[quality]) {
        return statistic.utilizedByQuality[quality]
      }
      return 0
    },
    getStatisticByQuality (statistic, quality) {
      let amountByQuality = this.statisticsColumnList.filter(sc => sc.type === 'LABELLED_AMOUNT').length ? this.getStatisticAmountByQuality(statistic, quality) : ''
      let utilizedByQuality = this.statisticsColumnList.filter(sc => sc.type === 'LABELLED_PERCENTAGE').length ? this.getStatisticUtilizedByQuality(statistic, quality) : ''
      return (amountByQuality ? amountByQuality.toLocaleString() : '') + (amountByQuality && utilizedByQuality ? ' / ' : '') + (utilizedByQuality ? utilizedByQuality.toFixed(1) + '%' : '')
    },
    showExpandIconForStatistic (statistic) {
      return statistic.type === 'SUMMARY' && !this.isStatisticExpanded(statistic)
    },
    showCollapseIconForStatistic (statistic) {
      return statistic.type === 'SUMMARY' && this.isStatisticExpanded(statistic)
    },
    statisticClicked (statistic) {
      let expanded = this.isStatisticExpanded(statistic)
      expanded = !expanded
      this.$set(this.expandedStatistics, statistic.treeAge, expanded)
      this.updateCounter++
    },
    isStatisticExpanded (statistic) {
      return this.expandedStatistics[statistic.treeAge] !== undefined && this.expandedStatistics[statistic.treeAge] === true
    },
    showStatisticsColum (column) {
      return this.statisticsColumnList.filter(c => c.type === column).length
    },
    getTotalSizeSupplier (suppliers) {
      let size = 0
      if (suppliers && suppliers.length) {
        for (let supplier of suppliers) {
          if (supplier.size) {
            size += supplier.size
          }
        }
      }
      return size
    },
    getTotalForecastSupplier (suppliers) {
      let forecast = 0
      if (suppliers && suppliers.length) {
        for (let supplier of suppliers) {
          if (supplier.forecast) {
            forecast += supplier.forecast
          }
        }
      }
      return forecast
    },
    getTotalHarvestSizeSupplier (suppliers) {
      let harvestSize = 0
      if (suppliers && suppliers.length) {
        for (let supplier of suppliers) {
          if (supplier.harvestSize) {
            harvestSize += supplier.harvestSize
          }
        }
      }
      return harvestSize
    },
    printContract () {
      let url = '/backend/print/supplierContract.xhtml?supplierContractId=' + this.currentContract.id + '&title=Contract no. ' + this.currentContract.number + '&uuid=' + uuid()
      window.open(url)
    },
    startSendContract () {
      this.sendContractStarted = true
      this.sendEmail = this.currentContract.supplier.email
      this.sendSubject = ''
      this.sendMessage = ''
      axios.get('/backend/rest/supplier_contract/' + this.currentContract.id + '/mail_info')
        .then(response => {
          this.sendSubject = response.data.subject
          this.sendMessage = response.data.message
        })
    },
    createContract () {
      this.currentContract = {
        id: null,
        supplier: {
          id: this.currentSupplier.id
        },
        number: '',
        contractText: '',
        buyerSignaturePlace: '',
        buyerSignatureDate: DateUtil.dateToString(new Date()),
        comment: ''
      }
      this.contractDirty = false

      let salesOrgId = this.currentSupplier.salesOrganization.id
      let locale = 'da'

      // Initialize the next contract number
      axios.get('/backend/rest/sales_organization/' + salesOrgId)
        .then(response => {
          let salesOrganization = response.data
          this.currentContract.number = salesOrganization.supplierContractNumberSequence
        })

      // Initialize the contract text
      axios.get('/backend/rest/configuration/TemplateSupplierContractText_' + locale + '?salesOrganization=' + salesOrgId)
        .then(response => {
          this.currentContract.contractText = response.data.value
        })
    },
    displayContract (contract) {
      this.currentContract = JSON.parse(JSON.stringify(contract))
      this.contractDirty = false
    },
    saveContract () {
      axios.post('/backend/rest/supplier_contract', this.currentContract)
        .then(response => {
          this.loadContract(true)
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })
    },
    deleteContract () {
      axios.delete('/backend/rest/supplier_contract/' + this.currentContract.id)
        .then(response => {
          this.confirmDeleteContractDialog = false
          this.currentContract = null
          this.contract = null
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    cancelContract () {
      this.currentContract = null
    },
    sendContract () {
      let contractSend = {
        contractId: this.currentContract.id,
        email: this.sendEmail,
        subject: this.sendSubject,
        message: this.sendMessage
      }
      axios.post('/backend/rest/supplier_contract/send', contractSend)
        .then(response => {
          this.$refs.header.showSnackbar('Contract has been sent to supplier')
          this.sendContractStarted = false
          this.loadContract(true)
        })
        .catch(error => {
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })
    }
  },
  watch: {
    sessionSalesOrganizations () {
      this.loadSuppliers()
      this.loadFilterSuppliers()
      this.loadSupplierFieldChartSummaries()
      this.filterSupplierList = []
      this.otherFilterSupplierList = []
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  tr.supplierFields td:not(.action) {
    padding: 0 0 0 15px !important;
  }
  tr.supplierFields td.action {
    padding: 0 8px !important;
  }
  tr.supplierFields td .v-input {
    padding: 0 !important;
  }
  tr.supplierPickupAddresses td:not(.action) {
    padding: 0 0 0 15px !important;
  }
  tr.supplierPickupAddresses td.action {
    padding: 0 8px !important;
  }
  tr.supplierPickupAddresses td .v-input {
    padding: 0 !important;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
  .alignRight input {
    text-align: right;
  }
  .v-input--selection-controls__ripple {
    height: 15px !important;
  }
  tr.subTotal td,
  tr.total td {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.54);
  }
  tr td.amount {
    line-height: 22px;
  }
  tr.subTotal td.category,
  tr.subTotal td.amount {
    padding-bottom: 10px !important;
  }
  tr.total td div.total,
  tr.total td.amount {
    padding-top: 10px !important;
  }
  tr.subTotal td div.subTotal {
    padding-top: 2px !important;
    text-align: left;
  }
  .small,
  .small label {
    font-size: 13px !important;
    line-height: 20px !important;
  }

  .fieldSummaryValue {
    width: 70px;
    text-align: right;
    display: inline-block;
  }
  .productionIntro {
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 13px;
  }
  .productionIntro tr td {
    padding-right: 30px;
    line-height: 18px;
  }
  .productionIntro tr td label {
    line-height: 18px;
  }
  .statistics table tr td {
    height: 23.5px !important;
  }
  table.v-table tbody tr.statisticsTotal td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    font-weight: bold;
  }
  table tr.supplierTotal {
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Suppliers.vue